<template>
  <div id="app">
    <loading-spinner :visible="$root.loading" />
    <div class="content-container">
      <!-- Левая колонка -->
      <router-view :key="$route.fullPath"></router-view>

      <div @click="openChat('830dd4256592b5f9688711577330fc61')"></div>

      <TaskReminderPanel
        :reminders="taskReminders"
        @open-order="openTaskReminderOrder"
        @complete="completeTaskReminder"
        @snooze="snoozeTaskReminder"
      />

      <div class="modalChats">
        <ChatModalManager ref="chatModal" />
      </div>

      

  

       
      <!-- Правая колонка с компонентом SavedOrders в липкой позиции -->
       

      <div v-if="$route.name !== 'Login' && $route.name !== 'CalendarComponent' && $route.name !== 'TaskSto'" :class="['sticky-saved-orders', {minimized: isMinimized}]">
        
        <div class="arrowCont"><div class="arrowHide" @click="toggleMinimized">



         <svg v-if="isMinimized" xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24" style="transform: rotate(180deg);">
            <path d="M7.293 4.707L14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/>
        </svg>
        
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24" >
            <path d="M7.293 4.707L14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/>
        </svg>


          
        </div></div>

        <div class="hidElem" v-show="!isMinimized">
        
          <saved-orders :savedForms="savedForms" />
          <new-orders />
          <missed-calls :calls="calls" @delete-call="handleDeleteCall" />
          <div class="calls-display-settings" style="padding: 12px; border-top: 1px solid #e0e0e0; background-color: #f8f9fa;">
            <label style="display: flex; align-items: center; font-size: 12px; cursor: pointer; flex-wrap: wrap; gap: 8px;">
              <span style="margin-right: 4px; color: #495057; font-weight: 500; white-space: nowrap;">Уведомления о звонках:</span>
              <select v-model="maxCallNotifications" @change="saveCallNotificationsSetting" style="padding: 6px 10px; border: 1px solid #ced4da; border-radius: 4px; font-size: 12px; cursor: pointer; background-color: #fff; color: #495057; min-width: 120px; transition: border-color 0.2s;">
                <option value="all">Все</option>
                <option value="3">3 последних</option>
                <option value="1">1 последний</option>
              </select>
            </label>
          </div>
           <div class="logout-container">
          <div v-if="isAuthenticated" class="manager-status-block" style="margin-bottom: 8px;">
            <span style="font-size: 12px; color: #495057; margin-right: 6px;">Статус:</span>
            <select v-model="currentManagerStatus" @change="setManagerStatus" style="padding: 4px 8px; border-radius: 4px; border: 1px solid #ced4da; font-size: 12px; background: #fff; cursor: pointer;">
              <option value="online">Онлайн</option>
              <option v-if="!isLogist" value="away">Отошел</option>
            </select>
          </div>
          <button @click="logout" class="logout-button">Выход</button>
          <div v-if="isAuthenticated && loggedInToday.length" class="logged-in-today">
            Доступны для раздачи заказов: {{ loggedInToday.map(m => m.label).join(', ') }}
          </div>
        </div>
        </div>

      </div>

    </div>
    

    
    
  </div>
</template>


<script>
import { ORDERS_API_BASE } from '@/config/api';
import Vue from 'vue';
import axios from 'axios';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import LoadingSpinner from './components/LoadingSpinner.vue';
import NewOrders from './components/NewOrders.vue';
import MissedCalls from './components/MissedCalls.vue';
import SavedOrders from './components/SavedOrders.vue';
import CallNotification from './components/CallNotification.vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { mapState, mapActions, mapGetters } from 'vuex';
import ChatModalManager from './components/ChatModalManager.vue';

import Notification from './components/Notification.vue'; // уведомления
import TaskReminderPanel from './components/TaskReminderPanel.vue';
import { extractManagerCode, findManagerLabel } from './utils/managerLookup';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Toast);

export default {
  name: 'App',
  components: {
    LoadingSpinner,
    MissedCalls,
    NewOrders,
    SavedOrders,
    ChatModalManager,
    TaskReminderPanel,
  },
  data() {
    return {
      isMinimized: true,
      isFormBeingSaved: false,
      user:'',
      lastBridgeUniqueId:null,
      lastStartUniqueId:null,
      lastOutgoingPhone:null,
      lastOutgoingAt:0,
      lastIncomingPhone:null,
      lastIncomingAt:0,
      lastBridgeToken:null,
      logoutTimer: null,
      inactivityTimer: null,
      lastActivitySent: 0,
      ACTIVITY_THROTTLE_MS: 25000,
      processingPhones: new Set(),
      ws: null, // WebSocket соединение
      sources: [], // Хранилище для данных из источника json
      calls: [], // Пропущенные звонки
      displayedCalls: new Set(),
      activeNotifications: new Map(),
      taskReminders: [], // Компактные напоминания по задачам
      pendingOrderId: null, // Сохраненный orderId для привязки при hangup
      maxCallNotifications: 'all', // Настройка количества уведомлений о входящих звонках: 'all', '3', '1'
      callNotificationsOrder: [], // Порядок добавления уведомлений для отслеживания старых
      loggedInToday: [], // Кто сегодня залогинен и в статусе «Онлайн» (для раздачи заказов)
      currentManagerStatus: 'online', // Текущий статус менеджера: online / away
      managersList: [] // Справочник managers (customFields.manager)
    };
  },
provide() {
    return {
      ws: () => this.ws, // Делаем WebSocket доступным через provide
    };
  },
  computed: {
   ...mapState({
      savedForms: state => state.savedFormsModule.savedForms // Доступ к savedForms из Vuex модуля
    }),
  ...mapGetters("sourceModule", {
    getTrunkByPhone: "getTrunkByPhone", // Подключение геттера как вычисляемого свойства
  }),
    isAuthenticated() {
      return !!localStorage.getItem('user');
    },
    currentUser() {
      const u = localStorage.getItem('user');
      return u ? JSON.parse(u) : null;
    },
    isManager() {
      const u = this.currentUser;
      return u && (u.role || '').trim() === 'Менеджеры';
    },
    isLogist() {
      const u = this.currentUser;
      const role = (u && u.role) || '';
      const r = String(role).toLowerCase();
      return role && (r.includes('логист') || r === 'logist');
    }
  },
  watch: {
    isLogist: {
      immediate: true,
      handler(val) {
        if (val && this.currentManagerStatus === 'away') {
          this.currentManagerStatus = 'online';
        }
      }
    }
  },
  mounted() {
      this.$store.dispatch('savedFormsModule/loadSavedForms');
      // Загружаем настройку количества уведомлений о звонках
      this.loadCallNotificationsSetting();
    // Запрашиваем разрешение, если оно ещё не установлено
  if (Notification.permission === 'default') {
    Notification.requestPermission().then(permission => {
      console.log('Notification permission:', permission);
      if (permission === 'denied') {
        // Сообщите пользователю, что для полноценной работы уведомлений следует изменить настройки
        this.$toast.warning("Чтобы получать уведомления даже в фоновом режиме, разрешите системные уведомления в настройках браузера.");
      }
    });
  } else if (Notification.permission === 'denied') {
    // Если уже отклонено, можно показать предупреждение
    this.$toast.warning("Системные уведомления отключены. Чтобы получать уведомления в фоновом режиме, включите их в настройках браузера.");
  };
    this.checkLoginState();
    this.startLogoutTimers();
    if (!this.isAuthenticated) {
      this.$router.push('/login');
    } else {
      this.user = this.$store.state.user;
      this.loadSavedForms(); // Загрузка savedForms при монтировании
      console.log("Сохраненные формы:", this.savedForms);
      this.loadSources(); // Загружаем данные из source.json
      this.loadMissedCalls(); // Загружаем звонки из сервера
      this.setupWebSocket();
      this.fetchLoggedInToday();
      this.fetchCurrentManagerStatus();
      this.loadManagersList();
      this.loggedInTodayInterval = setInterval(this.fetchLoggedInToday, 60 * 1000);
    }
  },
  
  methods: {
    async loadManagersList() {
      try {
        const response = await fetch(ORDERS_API_BASE + '/managers.php');
        const data = await response.json();
        this.managersList = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Ошибка при получении справочника managers:', error);
      }
    },
    applyManagerLabelToCall(incomingCall, managerValue) {
      const managerCode = extractManagerCode(managerValue);
      if (!managerCode) return;
      incomingCall.managerId = managerCode;
      const label = findManagerLabel(this.managersList, managerCode);
      if (label) {
        incomingCall.managerLabel = label;
      }
    },
    openChat(idclient) {
      this.$refs.chatModal.openChatModal(idclient);
    },
    toggleMinimized(){
      this.isMinimized = !this.isMinimized;
    },
    loadCallNotificationsSetting() {
      // Загружаем настройку из localStorage
      const saved = localStorage.getItem('maxCallNotifications');
      if (saved && ['all', '3', '1'].includes(saved)) {
        this.maxCallNotifications = saved;
      }
    },
    saveCallNotificationsSetting() {
      // Сохраняем настройку в localStorage
      localStorage.setItem('maxCallNotifications', this.maxCallNotifications);
    },
    limitCallNotifications() {
      // Ограничиваем количество уведомлений согласно настройке
      if (this.maxCallNotifications === 'all') {
        return; // Не ограничиваем
      }
      
      const limit = parseInt(this.maxCallNotifications, 10);
      
      // Если уведомлений больше лимита, удаляем самые старые
      while (this.callNotificationsOrder.length > limit && this.callNotificationsOrder.length > 0) {
        const oldestPhone = this.callNotificationsOrder.shift(); // Берем самое старое
        const toastId = this.activeNotifications.get(oldestPhone);
        if (toastId) {
          this.$toast.dismiss(toastId); // Закрываем уведомление
          this.activeNotifications.delete(oldestPhone); // Удаляем из Map
        }
      }
    },
    checkLoginState() {
      const user = JSON.parse(localStorage.getItem('user'));
      const loginTime = parseInt(localStorage.getItem('loginTime'), 10);

     /* if (!user || !loginTime) {
        this.logout(); // Если нет пользователя или времени входа, разлогиниваем
        return;
      }*/

      const now = Date.now();
      const timeElapsed = now - loginTime;
      const maxSessionTime = 8 * 60 * 60 * 1000; // 8 часов в миллисекундах

     /* if (timeElapsed > maxSessionTime) {
        this.logout(); // Сессия истекла
      }*/
    },

    startLogoutTimers() {
      // Таймер для автоматического выхода через 8 часов
      const maxSessionTime = 8 * 60 * 60 * 1000;
      const remainingTime = maxSessionTime - (Date.now() - parseInt(localStorage.getItem('loginTime'), 10));

     /* this.logoutTimer = setTimeout(() => {
        this.logout();
      }, Math.max(remainingTime, 0));*/

      // Таймер бездействия (30 минут)
      this.resetInactivityTimer();

      // Отслеживание активности (10 мин бездействия → разлогин; throttle отправки на сервер)
      document.addEventListener('mousemove', this.resetInactivityTimer);
      document.addEventListener('keydown', this.resetInactivityTimer);
      document.addEventListener('click', this.resetInactivityTimer);
      document.addEventListener('scroll', this.resetInactivityTimer);
    },

    resetInactivityTimer() {
      const inactivityLimit = 4 * 60 * 60 * 1000;
      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
      this.sendUserActivity();
    },

    sendUserActivity() {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN || !this.$store.state.user) return;
      const now = Date.now();
      if (now - this.lastActivitySent < this.ACTIVITY_THROTTLE_MS) return;
      this.lastActivitySent = now;
      try {
        this.ws.send(JSON.stringify({ type: 'userActivity' }));
      } catch (e) {}
    },
    async fetchLoggedInToday() {
      try {
        const res = await fetch('https://manager.1akb.by/managers-logged-in-today');
        if (res.ok) {
          const list = await res.json();
          this.loggedInToday = Array.isArray(list) ? list : [];
        }
      } catch (e) {
        this.loggedInToday = [];
      }
    },
    async fetchCurrentManagerStatus() {
      if (!this.currentUser || (this.currentUser.role || '').trim() !== 'Менеджеры') return;
      try {
        const res = await fetch('https://manager.1akb.by/managers-status');
        if (!res.ok) return;
        const list = await res.json();
        const me = (list || []).find((m) => Number(m.id) === Number(this.currentUser.id));
        if (me && (me.status === 'online' || me.status === 'away')) this.currentManagerStatus = me.status;
      } catch (e) {}
    },
    setManagerStatus() {
      const status = this.currentManagerStatus === 'away' ? 'away' : 'online';
      const userId = this.currentUser && this.currentUser.id;
      if (!userId) return;
      fetch('https://manager.1akb.by/manager-status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, status })
      }).then((r) => {
        if (r.ok) this.sendWsManagerStatus(status);
      }).catch(() => {});
    },
    sendWsManagerStatus(status) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        try {
          this.ws.send(JSON.stringify({ type: 'setManagerStatus', status }));
        } catch (e) {}
      }
    },

    logout() {
      clearTimeout(this.logoutTimer);
      clearTimeout(this.inactivityTimer);

      // Закрываем WebSocket — сервер перестаёт считать пользователя онлайн
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.close();
      }
      this.ws = null;

      // Очистка localStorage и Vuex состояния
      localStorage.removeItem('user');
      localStorage.removeItem('loginTime');
      this.$store.commit('setUser', null);

      // Удаление слушателей активности
      document.removeEventListener('mousemove', this.resetInactivityTimer);
      document.removeEventListener('keydown', this.resetInactivityTimer);
      document.removeEventListener('click', this.resetInactivityTimer);
      document.removeEventListener('scroll', this.resetInactivityTimer);

      // Переход на страницу входа
      this.$router.push('/login');
    },

    ...mapActions({
      // Подключение экшенов из модуля savedFormsModule
      loadSavedForms: "savedFormsModule/loadSavedForms",
      saveForm: "savedFormsModule/saveForm",
      deleteForm: "savedFormsModule/deleteForm",

      // Подключение экшенов из модуля sourceModule
      addPhoneTrunk: "sourceModule/addPhoneTrunk", // Добавление phone -> trunk
    }),


handleDeleteCall(phone) {
    // Удаляем звонок локально
    this.calls = this.calls.filter((call) => call.phone !== phone);

    // Сохраняем изменения в localStorage
    localStorage.setItem("missedCalls", JSON.stringify(this.calls));

    // Отправляем запрос на сервер для удаления звонка
    fetch("https://manager.1akb.by/removeMissedCall", {
        method: "POST",
        headers: {
            "Content-Type": "application/json", // Указываем тип содержимого
        },
        body: JSON.stringify({ phone }), // Передаём данные в формате JSON
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Ошибка удаления звонка: ${response.status}`);
            }
            return response.json(); // Обработка ответа сервера
        })
        .then((data) => {
            console.log(`Звонок с номером ${phone} удалён с сервера`, data);
        })
        .catch((error) => {
            console.error("Ошибка удаления звонка с сервера:", error.message);
        });
},

    

    async loadSources() {
      try {
        const response = await fetch("/source.json"); // Загрузка JSON
        this.sources = await response.json();
        console.log("Источники загружены:", this.sources);
      } catch (error) {
        console.error("Ошибка загрузки sources.json:", error);
      }
    },
    getSourceById(trunk) {
      // Ищем источник по ID (trunk)
      return this.sources.find((source) => source.ID === trunk) || {
        label: "Неизвестный источник",
        value: "unknown",
      };
    },

    saveFormAndUpdate(newForm) {
      this.saveForm(newForm); // Сохраняем форму через Vuex
    },

  async saveBridgeCallAsForm(phone, source) {
  console.log("=== saveBridgeCallAsForm NA4ALOS ===");
  console.log("phone:", phone);
  console.log("source:", source);
  console.log("lastBridgeUniqueId:", this.lastBridgeUniqueId);
  
  const formId = this.generateUniqueId();

  // Проверяем, есть ли уже форма с таким номером телефона в savedForms
  const existingForm = this.savedForms.find(
    (form) => form && form.phone === phone
  );

  console.log("existingForm:", existingForm);

  if (existingForm) {
    console.log("=== SU6ESTVUYu6AYA FORMA NAJDENA V saveBridgeCallAsForm ===");
    alert(`Форма с номером телефона ${phone} уже существует!`);
    console.log(`Форма с номером телефона ${phone} уже существует в savedForms.`);
    return; // Не добавляем форму, если она уже есть
  }


  let site_block;

  if(this.user.retailCrmId == 126) {
     site_block = {label: "СТО", value: "sto-prodaza"};
  }
  else {
    site_block = {label: "Центральный офис 1akb.by", value: "1akb-by"};
  }



  // Формируем объект данных формы
  const formOrder = {
    order: {
      id: formId,
      orderType: {label: "Физическое лицо", value: "eshop-individual"},
      site: site_block,
      /*managerId: {
        label: this.user.label, // Передаём label
        value: this.user.retailCrmId, // Передаём value
      },*/
      orderMethod: {
        label: source.label, // Передаём label
        value: source.value, // Передаём value
      },
      contragent:{
        contragentType:{ label: 'Физическое лицо', value: 'individual' },
      },
      
      data: {
        phone, // Сохраняем только номер телефона
        
      },
      products: [], // Пустой массив продуктов
      comments: {
        customerComment: '',
        managerComment: '',
      },
      shipment: {
        shipmentDate: null,
        deliveryCost: null,
        deliveryAddress: '',
        deliveryDate: null,
        weight: null,
        dimensions: {
          length: null,
          width: null,
          height: null,
        },
      },
      deliveryTime: {
        from: null,
        to: null,
      },
      customTime: null,
      oneTimeDiscountAmount: null,
      oneTimeDiscountPercent: null,
      customFields: {
        manager: {
          label: this.user.label,
          value: this.user.symbolicCode || this.user.retailCrmId
        }
      }
    }
  };

  // Сохраняем форму через Vuex
  //this.saveForm(formData);
  console.log("=== OTPRAVLENIE ZAKAZA V CRM ===");
  console.log("formOrder:", formOrder);
  console.log("lastBridgeUniqueId:", this.lastBridgeUniqueId);
  
  try {
                    const response = await axios.post(ORDERS_API_BASE + '/saveCallOrder.php', formOrder);
                    console.log("=== OTVET OT CRM ===");
                    console.log("response.data:", response.data);
                    
                        if (response.data.success) {
                            const { orderId, orderSite, numberOrder, orderCreated } = response.data;
                            console.log("=== ZAKAZ SOZDAN USPESNO ===");
                            console.log("orderId:", orderId);
                            console.log("orderSite:", orderSite);
                            console.log("numberOrder:", numberOrder);
                            console.log("orderCreated:", orderCreated);
                            // Сохраняем order_id в таблицу звонков по uniqueId
                            // Приоритет: lastStartUniqueId > lastBridgeUniqueId
                            const candidateIds = [
                                this.lastStartUniqueId,  // Приоритет 1: ID из события /start
                                this.lastBridgeUniqueId  // Приоритет 2: ID из bridge (может быть неправильным)
                            ].filter(Boolean);
                            
                            if (orderId) {
                                console.log("=== SOHRANYAEM ORDER_ID DLYA PRIVYAZKI ===");
                                console.log("orderId:", orderId);
                                // Сохраняем orderId для привязки при hangup
                                this.pendingOrderId = orderId;
                                console.log("pendingOrderId установлен:", this.pendingOrderId);
                            } else {
                                console.warn('NET UniqueId ILI orderId DLYA SVYAZI ZVONKA I ZAKAZA IZ saveBridgeCallAsForm!');
                                console.warn('lastStartUniqueId:', this.lastStartUniqueId);
                                console.warn('lastBridgeUniqueId:', this.lastBridgeUniqueId);
                                console.warn('orderId:', orderId);
                            }
                            //this.$router.push({ name: 'OrderEdit', params: { orderId, site: orderSite } });
                            const formData = { id:orderId, number:numberOrder, idorder:orderId, site: orderSite ? orderSite : {label: "Центральный офис 1akb.by", value: "1akb-by"}, created:orderCreated, phone:phone, orderMethod:{label: source.label,value: source.value}};
                            this.loading = false;
                            alert('Заказ успешно созданнн!');
                            this.$store.dispatch('savedFormsModule/clearSavedForms');
                            this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
                            this.saveForm(formData);
                        } else {
                            this.loading = false;
                            alert('Ошибка при создании заказа: ' + response.data.message);
                        }
                    } catch (error) {
                        console.error('Ошибка при создании заказа:', error);
                        alert('Произошла ошибка при создании заказаffff.');
                        this.loading = false;
                    }
  /*console.log(
    `Форма с номером телефона ${phone} успешно сохранена. Источник: ${source.label} (${source.value})`
  );*/
},


saveBridgeCallAsFormOrder(phone, number, numberOrder, managerId, orderMethod, orderType, site, contragentType, createdAt, source) {
  console.log("=== saveBridgeCallAsFormOrder NA4ALOS ===");
  console.log("phone:", phone);
  console.log("number:", number);
  console.log("numberOrder:", numberOrder);
  console.log("managerId:", managerId);
  console.log("lastBridgeUniqueId:", this.lastBridgeUniqueId);
  
  //const formId = this.generateUniqueId();

  // Проверяем, есть ли уже форма с таким номером телефона в savedForms
  const existingForm = this.savedForms.find(
    (form) => form && form.phone === phone
  );

  console.log("existingForm:", existingForm);

  if (existingForm) {
    console.log("=== SU6ESTVUYu6AYA FORMA NAJDENA ===");
    alert(`Форма с номером телефона ${phone} уже существует!`);
    console.log(`Форма с номером телефона ${phone} уже существует в savedForms.`);
    
    // Приоритет: сначала lastStartUniqueId, потом lastBridgeUniqueId
    const candidateIds = [
        this.lastStartUniqueId,  // Приоритет 1: ID из события /start
        this.lastBridgeUniqueId  // Приоритет 2: ID из bridge (может быть неправильным)
    ].filter(Boolean);
    
    if (number) {
        console.log("=== SOHRANYAEM ORDER_ID DLYA SU6ESTVUYu6EY FORMY ===");
        console.log("orderId:", number);
        // Сохраняем orderId для привязки при hangup
        this.pendingOrderId = number;
        console.log("pendingOrderId установлен:", this.pendingOrderId);
    } else {
        console.warn('NET UniqueId ILI orderId DLYA SVYAZI ZVONKA I ZAKAZA DLYA SU6ESTVUYu6EY FORMY!');
        console.warn('lastStartUniqueId:', this.lastStartUniqueId);
        console.warn('lastBridgeUniqueId:', this.lastBridgeUniqueId);
        console.warn('number:', number);
    }
    return; // Не добавляем форму, если она уже есть
  }

  // Если форма не найдена, но заказ существует в БД (number передан),
  // значит другой менеджер создал заказ - открываем существующий заказ
  if (number) {
    console.log("=== ZAKAZ SU6ESTVUET V BD, NO FORMA U DRUGOGO MANAGERA ===");
    console.log("Открываем существующий заказ:", number);
    console.log("numberOrder:", numberOrder);
    
    // Сохраняем orderId для привязки при hangup
    this.pendingOrderId = number;
    console.log("pendingOrderId установлен:", this.pendingOrderId);
    
    // Связываем звонок с существующим заказом
    const candidateIds = [
        this.lastStartUniqueId,
        this.lastBridgeUniqueId
    ].filter(Boolean);
    
    if (candidateIds.length > 0 || this.lastBridgeUniqueId) {
        console.log("=== SVYAZYVAEM ZVONOK S SU6ESTVUYu6IM ZAKAZOM ===");
        if (this.lastBridgeUniqueId) {
            this.garantirovannoeSvyazyvanieByBridge({
                bridgeUniqueId: this.lastBridgeUniqueId,
                orderId: number,
                token: this.lastBridgeToken,
                candidateIds: candidateIds
            });
        } else if (this.lastStartUniqueId) {
            this.garantirovannoeSvyazyvanie(this.lastStartUniqueId, number);
        }
    }
    
    // Открываем существующий заказ
    const formData = {
      id: number,
      idorder: number,
      number: numberOrder,
      site: site ? (typeof site === 'object' ? site : { value: site }) : { label: "Центральный офис 1akb.by", value: "1akb-by" },
      created: createdAt,
      phone: phone,
      orderMethod: { label: source.label, value: source.value }
    };
    
    this.loading = false;
    this.$store.dispatch('savedFormsModule/clearSavedForms');
    this.$store.commit('clearProducts');
    this.saveForm(formData);
    
    // Переходим на страницу существующего заказа
    const siteValue = site ? (typeof site === 'object' ? site.value : site) : '1akb-by';
    const siteObject = site ? (typeof site === 'object' ? site : { label: "Центральный офис 1akb.by", value: siteValue }) : { label: "Центральный офис 1akb.by", value: "1akb-by" };
    
    this.$router.push({
      name: 'OrderEdit',
      params: { orderId: number, site: siteObject }
    });
    
    return; // Не создаем новый заказ
  }

  // Если заказ не существует (number не передан), создаем новый
  console.log("=== SOZDANIE NOVOGO ZAKAZA ===");
  console.log("number:", number);
  
  // Это не должно произойти, так как эта функция вызывается только когда managerId найден,
  // что означает, что заказ должен существовать. Но на всякий случай оставляем проверку
  console.warn('ZAKAZ NE NAJDEN, NO VYZVAN saveBridgeCallAsFormOrder. ETO NE DOVZHNO PROIZOYT.');
                        
},

    generateUniqueId() {
      return Math.floor(Date.now() / 1000);
    },

    // Функция для гарантированного связывания звонка с заказом
    async garantirovannoeSvyazyvanie(callId, orderId, maxAttempts = 3) {
      console.log("=== GARANTIROVANNOE SVYAZYVANIE ===");
      console.log("callId:", callId);
      console.log("orderId:", orderId);
      console.log("maxAttempts:", maxAttempts);
      
      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        console.log(`=== POPYTKA ${attempt} IZ ${maxAttempts} ===`);
        
        try {
          const response = await axios.post('https://manager.1akb.by/set-order-id-calls', {
            callId: callId,
            orderId: orderId
          });
          
          console.log(`USPESNO! POPYTKA ${attempt} ZAVERSHENA`);
          console.log('Response:', response.data);
          return true;
          
        } catch (error) {
          console.error(`OSHIBKA NA POPYTKE ${attempt}:`, error);
          console.error('Error details:', error.response && error.response.data);
          
          if (attempt < maxAttempts) {
            console.log(`ZHDEM 1 SEKUNDU PERED POPYTKOY ${attempt + 1}...`);
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
        }
      }
      
      console.error("VSE POPYTKI ISCHERPANY! SVYAZYVANIE NE UDALOS");
      return false;
    },

    // Функция для гарантированного связывания звонка с заказом через bridge
    async garantirovannoeSvyazyvanieByBridge({ bridgeUniqueId, orderId, token, candidateIds }, maxAttempts = 5) {
      console.log("========================================");
      console.log("=== GARANTIROVANNOE SVYAZYVANIE BY BRIDGE ===");
      console.log("bridgeUniqueId:", bridgeUniqueId);
      console.log("token:", token);
      console.log("candidateIds:", candidateIds);
      console.log("orderId:", orderId);
      console.log("maxAttempts:", maxAttempts);
      console.log("========================================");
      
      if (!orderId) {
        console.error("❌ orderId обязателен для связывания, выход");
        return false;
      }

      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        console.log(`=== POPYTKA ${attempt} IZ ${maxAttempts} ===`);
        
        try {
          console.log(`🔄 Попытка ${attempt}/${maxAttempts}: отправка запроса на /set-order-id-by-bridge`);
          const requestData = {
            bridgeUniqueId: bridgeUniqueId || null,
            token: token || null,
            candidateIds: candidateIds || [],
            orderId: orderId
          };
          console.log('📤 Данные запроса:', JSON.stringify(requestData, null, 2));
          
          const response = await axios.post('https://manager.1akb.by/set-order-id-by-bridge', requestData);
          
          console.log('📥 Ответ от сервера:', response.data);
          
          if (response.data.success) {
            console.log(`✅ УСПЕХ! Попытка ${attempt} завершена`);
            console.log('Response:', response.data);
            console.log(`Использован метод: ${response.data.method}, callId: ${response.data.callId}`);
            return true;
          } else {
            throw new Error(response.data.error || 'Unknown error');
          }
          
        } catch (error) {
          console.error(`❌ ОШИБКА на попытке ${attempt}:`, error.message);
          console.error('Error details:', error.response && error.response.data);
          
          if (attempt < maxAttempts) {
            const delay = Math.min(1000 * attempt, 3000); // Увеличиваем задержку с каждой попыткой
            console.log(`ZHDEM ${delay}ms PERED POPYTKOY ${attempt + 1}...`);
            await new Promise(resolve => setTimeout(resolve, delay));
          }
        }
      }
      
      console.error("VSE POPYTKI ISCHERPANY! SVYAZYVANIE NE UDALOS");
      return false;
    },

    loadMissedCallsFromStorage() {
      const savedCalls = localStorage.getItem('missedCalls');
      if (savedCalls) {
        this.calls = JSON.parse(savedCalls);
        this.calls.forEach(call => this.displayedCalls.add(call.id));
      }
    },
    async loadMissedCalls() {
        try {
            const response = await fetch('https://manager.1akb.by/missedCalls');
            const missedCalls = await response.json();
            console.log('Loaded missed calls from server:', missedCalls);
            this.calls = missedCalls;
            this.calls.reverse();

            // Сохраняем пропущенные звонки в localStorage
            this.saveMissedCallsToStorage();
        } catch (error) {
            console.error('Error fetching missed calls:', error);
        }
    },
    saveMissedCallsToStorage() {
        localStorage.setItem('missedCalls', JSON.stringify(this.calls));
    },
    normalizePhoneNumber(phone) {
        return phone ? phone.replace(/[^0-9]/g, '').replace(/^375/, '') : null;
    },
    /**
     * Ждём заказ, который создаёт webhook_server на /bridge.
     * Не создаём заказ с клиента — иначе дубли из‑за гонки с saveCallOrder.
     */
    async waitForAnsweredCallOrder(phone, statusGroups, { attempts = 12, delayMs = 700, callSite = null } = {}) {
      let last = { success: false };
      for (let i = 1; i <= attempts; i++) {
        last = await this.fetchPhoneManagerData(phone, statusGroups, callSite);
        if (last && last.success && last.number) {
          console.log(`waitForAnsweredCallOrder: заказ найден на попытке ${i}/${attempts}`, last.numberOrder || last.number);
          return last;
        }
        console.log(`waitForAnsweredCallOrder: заказ ещё нет, попытка ${i}/${attempts}`);
        if (i < attempts) {
          await new Promise((resolve) => setTimeout(resolve, delayMs));
        }
      }
      return last || { success: false };
    },

    async fetchPhoneManagerData(phone, statusGroups, callSite = null) {
        try {
            const payload = {
                phone,
                extendedStatus: statusGroups,
            };
            if (callSite && callSite !== 'unknown') {
                payload.callSite = callSite;
            }
            const response = await axios.post(ORDERS_API_BASE + '/getPhoneManager.php', payload);

            // Логируем полный ответ API для отладки
            console.log("=== fetchPhoneManagerData RESPONSE ===");
            console.log("Полный ответ API:", JSON.stringify(response.data, null, 2));
            console.log("response.data.customFieldsManager:", response.data.customFieldsManager);
            console.log("response.data.customFieldsManager тип:", typeof response.data.customFieldsManager);
            console.log("this.user.symbolicCode:", this.user.symbolicCode);
            console.log("this.user.symbolicCode тип:", typeof this.user.symbolicCode);

            // Проверяем наличие заказа по success и id, а не по manager (manager может быть пустым)
            if (response.data.success && response.data.id && response.data.orderNumber) {
                return {
                    success: true,
                    number: response.data.id,
                    numberOrder:response.data.orderNumber,
                    managerId: response.data.customFieldsManager || extractManagerCode(response.data.manager) || '',
                    orderMethod: response.data.orderMethod,
                    orderType: response.data.orderType,
                    site: response.data.site,
                    contragentType: response.data.contragentType,
                    createdAt: response.data.createdAt,
                    customFieldsManager: response.data.customFieldsManager || null,
                };
            }

            return { success: false };
        } catch (error) {
            console.error('Error fetching order data:', error.message);
            return { success: false };
        }
    },

    handleIncomingCall(callData) {
    if (callData.type === "forceLogout") {
      this.logout();
      return;
    }
    if (callData.type === "managersStatusUpdated") {
      this.fetchLoggedInToday();
      this.fetchCurrentManagerStatus();
      return;
    }
    if (callData.type === "managerAwayLong") {
      if (!this.isLogist) {
        this.$toast(`Менеджер ${callData.managerName || 'Менеджер'} в статусе «Отошел» более ${callData.minutes || 15} минут`, {
          timeout: 8000,
          position: "top-right",
          type: "warning"
        });
      }
      return;
    }
   if (callData.type === "orderRemoved" && callData.data && callData.data.id) {
      this.$store.commit("newOrdersModule/REMOVE_ORDER", callData.data.id);
      console.log(`Заказ ${callData.data.id} удален через WebSocket`);
    } else if (callData.type === "newOrders" && callData.data && Array.isArray(callData.data)) {
      this.$store.commit("newOrdersModule/SET_NEW_ORDERS", callData.data);
      console.log("Обновлены заказы через WebSocket");
    } else if (callData.type === "orderAssignedToYou") {
      const num = callData.orderNumber || callData.orderId || "";
      this.$toast("На вас назначен заказ №" + num, {
        timeout: 8000,
        position: "top-right",
        transition: "Vue-Toastification__fade",
        closeOnClick: true,
        style: {
          background: "linear-gradient(180deg, #fea530, #e69520)",
          color: "white",
          width: "320px",
          padding: "12px",
          fontSize: "15px",
          borderRadius: "4px"
        },
        icon: false
      });
    } else if (callData.type === "visitorReturned") {
      const me = this.currentUser || this.$store.state.user;
      const targetId = callData.managerUserId != null ? Number(callData.managerUserId) : null;
      if (targetId != null && me && Number(me.id) !== targetId) {
        return;
      }
      const code = callData.code || '';
      const num = callData.orderNumber || callData.orderId || '';
      const city = callData.city ? ` · ${callData.city}` : '';
      const pageHint = callData.pageTitle
        ? String(callData.pageTitle).slice(0, 80)
        : (callData.pagePath || 'АКБ');
      const message = `Клиент ${code} вернулся и смотрит АКБ${num ? ` (заказ №${num})` : ''}${city}\n${pageHint}`;
      this.$toast(message, {
        timeout: 20000,
        position: "top-right",
        transition: "Vue-Toastification__fade",
        closeOnClick: true,
        style: {
          background: "linear-gradient(180deg, #3b82f6, #2563eb)",
          color: "white",
          width: "360px",
          padding: "12px",
          fontSize: "14px",
          borderRadius: "4px",
          whiteSpace: "pre-line"
        },
        icon: false,
        onClick: () => {
          if (callData.orderId) {
            this.$router.push({ name: 'OrderEdit', params: { orderId: String(callData.orderId) } });
          }
        }
      });
      if (document.hidden && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
        const n = new Notification('Клиент вернулся на сайт', { body: message });
        n.onclick = () => { window.focus(); };
      }
    }

 else if (callData.type === "clientNotification") {
  // Проверяем, предназначено ли уведомление для текущего оператора по login
  if (
    callData.data.operatorLogin &&
    this.currentUser &&
    this.currentUser.login_talkme &&
    callData.data.operatorLogin === this.currentUser.login_talkme
  ) {
    // Обрабатываем через модуль чата
    this.$store.dispatch('chatModule/handleClientNotification', callData.data);
    
    // Формируем сообщение уведомления
    const message = `Неотвеченное сообщение более 1 минуты от клиента ${callData.data.name} ${callData.data.lastName}, телефон: ${callData.data.phone}`;
    
    // Показываем уведомление через toast
    const toastId = this.$toast(message, {
      timeout: false,
      position: "top-right",
      transition: "Vue-Toastification__fade",
      closeOnClick: true,
      style: {
        background: "linear-gradient(180deg, #22c993, #20a77f)",
        color: "white",
        width: "280px",
        padding: "8px",
        fontSize: "16px",
        borderRadius: "2px"
      },
      icon: false
    });
    
    // Сохраняем уведомление в activeNotifications (ключ – clientId)
    this.activeNotifications.set(callData.data.clientId, toastId);
    console.log(`Уведомление для оператора ${this.currentUser.login_talkme} показано`);

    // Если вкладка не активна, и разрешение на уведомления получено, показываем системное уведомление
    if (document.hidden && Notification.permission === 'granted') {
      const desktopNotification = new Notification("Новый клиентский диалог", {
        body: message,
        icon: '/path/to/your/icon.png' // укажите путь к вашей иконке, если есть
      });
      desktopNotification.onclick = () => {
        window.focus();
        // при необходимости можно выполнить переход на нужную страницу
      };
    }
  } else {
    console.log("Уведомление не предназначено для текущего оператора");
  }
}
else if (callData.type === "newMessage") {
  // Проверяем, предназначено ли уведомление для текущего оператора по login
  if (
    callData.data.operatorLogin &&
    this.currentUser &&
    this.currentUser.login_talkme &&
    callData.data.operatorLogin === this.currentUser.login_talkme
  ) {
    // Обрабатываем через модуль чата
    this.$store.dispatch('chatModule/handleNewMessage', callData.data);
    console.log(callData.data);
    
    const message = `Новое сообщение от клиента ${callData.data.name} ${callData.data.lastName}, телефон: ${callData.data.phone}. Текст: ${callData.data.messageText}`;
    const toastId = this.$toast(message, {
      timeout: false,
      position: "top-right",
      transition: "Vue-Toastification__fade",
      closeOnClick: true,
      style: {
        background: "linear-gradient(180deg, #22c993, #20a77f)",
        color: "white",
        width: "280px",
        padding: "8px",
        fontSize: "16px",
        borderRadius: "2px"
      },
      icon: false,
      onClick: () => {
        this.openChat(callData.data.dialogId)  
      }
    });
    this.activeNotifications.set(callData.data.clientId, toastId);
    console.log(`Уведомление для оператора ${this.currentUser.login_talkme} показано`);

    if (document.hidden && Notification.permission === 'granted') {
      const desktopNotification = new Notification("Новое сообщение", {
        body: message,
        icon: '/path/to/your/icon.png'
      });
      desktopNotification.onclick = () => {
        window.focus();
      };
    }
  } else {
    console.log("Уведомление не предназначено для текущего оператора");
  }
}


    else if (callData.type === 'missedCalls') {
        this.calls = callData.data;
        this.calls.reverse();
        console.log("Идет новый пропущенный звонок");
        callData.data.forEach(call => {
            if (!this.displayedCalls.has(call.id)) {
                this.displayedCalls.add(call.id);
            }
        });
        this.saveMissedCallsToStorage();
        }else if (callData.type === 'taskNotification') {
        console.log("Получено уведомление о задаче:", callData.data);

        if (Array.isArray(callData.data)) {
            callData.data.forEach(call => {
                    let performerLabel = "Не указан";
                    try {
                        const performer = typeof call.performer === 'string'
                          ? JSON.parse(call.performer)
                          : call.performer;
                        if (performer && performer.label) {
                            performerLabel = performer.label;
                        }
                    } catch (e) {
                        console.warn(`Не удалось распарсить performer: ${call.performer}`, e);
                    }

                    if (performerLabel == this.$store.state.user.label) {
                      this.enqueueTaskReminder({
                          id: call.id,
                          taskText: call.taskText,
                          orderIdLink: call.orderId,
                          orderId: call.orderNumber,
                          dueDate: call.dueDate || call.dueDateTime || '',
                          managerLabel: performerLabel
                      });
                    }
            });
        } else {
            console.warn("callData.data не является массивом:", callData.data);
        }
    }
    else if (callData.type === 'adminMessage') {
        // Обработка сообщения от администратора
        const messageData = callData.data;
        
        console.log('=== Обработка adminMessage ===');
        console.log('messageData:', messageData);
        console.log('this.currentUser:', this.currentUser);
        
        // Проверяем, предназначено ли сообщение текущему пользователю
        let shouldShow = false;
        
        if (messageData.recipientUserId === null || messageData.recipientUserId === undefined) {
            // Сообщение для всех
            console.log('Сообщение для всех пользователей');
            shouldShow = true;
        } else {
            // Сообщение для конкретного пользователя
            console.log('Сообщение для конкретного пользователя');
            console.log('recipientUserId:', messageData.recipientUserId, typeof messageData.recipientUserId);
            
            if (this.currentUser) {
                console.log('currentUser.id:', this.currentUser.id, typeof this.currentUser.id);
                console.log('currentUser.login_talkme:', this.currentUser.login_talkme);
                console.log('recipientLogin:', messageData.recipientLogin);
                
                // Проверяем по ID пользователя (с учетом возможных типов)
                const recipientId = parseInt(messageData.recipientUserId);
                const currentUserId = parseInt(this.currentUser.id);
                console.log('recipientId (parsed):', recipientId);
                console.log('currentUserId (parsed):', currentUserId);
                
                const matchesById = !isNaN(recipientId) && !isNaN(currentUserId) && recipientId === currentUserId;
                console.log('matchesById:', matchesById);
                
                // Проверяем по login_talkme
                const matchesByLogin = messageData.recipientLogin && 
                                     this.currentUser.login_talkme && 
                                     messageData.recipientLogin === this.currentUser.login_talkme;
                console.log('matchesByLogin:', matchesByLogin);
                
                if (matchesById || matchesByLogin) {
                    console.log('✓ Сообщение предназначено текущему пользователю');
                    shouldShow = true;
                } else {
                    console.log('✗ Сообщение НЕ предназначено текущему пользователю');
                }
            } else {
                console.log('✗ currentUser не найден');
            }
        }
        
        if (shouldShow) {
            const messageText = messageData.senderName 
                ? `${messageData.senderName}: ${messageData.message}`
                : messageData.message;
            
            // Показываем уведомление на 10 секунд
            this.$toast(messageText, {
                timeout: 10000, // 10 секунд
                position: "top-right",
                transition: "Vue-Toastification__fade",
                closeOnClick: true,
                style: {
                    background: "linear-gradient(180deg, #2979ff, #1852a6)",
                    color: "white",
                    width: "320px",
                    padding: "12px",
                    fontSize: "16px",
                    borderRadius: "4px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                },
                icon: false
            });
        }
    }
    else if (callData.type === 'start') {
      console.log("Идет новый входящий звонок");
      
      // start — только для роли "Менеджеры"
      const currentUserData = this.$store.state.user || this.user || this.currentUser;
      const userRole = (currentUserData && currentUserData.role) ? String(currentUserData.role).trim() : '';
      console.log('userRole (start):', userRole);
      if (userRole !== 'Менеджеры') {
        console.log('Уведомление start скрыто: роль "' + userRole + '" не является "Менеджеры"');
        return;
      }
        // ========================================

      this.lastStartUniqueId = callData.data.UniqueId;
      console.log("USTANOVLEN lastStartUniqueId:", this.lastStartUniqueId);
      if (callData.data.phone) {
        this.lastIncomingPhone = this.normalizePhoneNumber(callData.data.phone);
        this.lastIncomingAt = Date.now();
      }



      const incomingCall = {
        id: callData.data.UniqueId,
        phone: callData.data.phone,
        timestamp: new Date(),
        orderid:
          callData.data.order && callData.data.order.number
            ? callData.data.order.number
            : null,
        managerId:
          callData.data.order && callData.data.order.managerId
            ? callData.data.order.managerId
            : null,
        missed: false,
      };

      this.applyManagerLabelToCall(
        incomingCall,
        callData.data.order && callData.data.order.managerId
      );

      // Сохраняем связь phone -> trunk в Vuex
      if (callData.data.phone && callData.data.trunk) {
        this.addPhoneTrunk({ phone: callData.data.phone, trunk: callData.data.trunk }); // Обращение к data
      }

      this.showCallNotification(incomingCall, "Входящий звонок");
    }
    else if (callData.type === 'startincoming') {
      console.log("Идет исходящий звонок");
      const outgoingPhone = callData.data && (callData.data.phone || callData.data.Phone);
      this.lastOutgoingPhone = outgoingPhone ? this.normalizePhoneNumber(outgoingPhone) : null;
      this.lastOutgoingAt = Date.now();
     }
    else if (callData.type === 'startsto') {
      console.log("Идет новый входящий звонок СТО");
      this.lastStartUniqueId = callData.data.UniqueId;
      console.log("USTANOVLEN lastStartUniqueId (STO):", this.lastStartUniqueId);

      const incomingCall = {
        id: callData.data.UniqueId,
        phone: callData.data.phone,
        timestamp: new Date(),
        orderid:
          callData.data.order && callData.data.order.number
            ? callData.data.order.number
            : null,
        managerId:
          callData.data.order && callData.data.order.managerId
            ? callData.data.order.managerId
            : null,
        missed: false,
      };

      this.applyManagerLabelToCall(
        incomingCall,
        callData.data.order && callData.data.order.managerId
      );

      // Сохраняем связь phone -> trunk в Vuex
      if (callData.data.phone && callData.data.trunk) {
        this.addPhoneTrunk({ phone: callData.data.phone, trunk: callData.data.trunk }); // Обращение к data
      }

      this.showCallNotificationSTO(incomingCall, "Входящий звонок");
    }
    else if (callData.type === 'startcontrol') {
      console.log("Идет новый входящий звонок Отдел Контроля");
      
      // startcontrol — только для роли "Контроль"
      const currentUserDataCtrl = this.$store.state.user || this.user || this.currentUser;
      const userRoleCtrl = (currentUserDataCtrl && currentUserDataCtrl.role) ? String(currentUserDataCtrl.role).trim() : '';
      console.log('userRole (startcontrol):', userRoleCtrl);
      if (userRoleCtrl !== 'Контроль') {
        console.log('Уведомление startcontrol скрыто: роль "' + userRoleCtrl + '" не является "Контроль"');
        return;
      }
      
      this.lastStartUniqueId = callData.data.UniqueId;
      console.log("USTANOVLEN lastStartUniqueId (Control):", this.lastStartUniqueId);

      const incomingCall = {
        id: callData.data.UniqueId,
        phone: callData.data.phone,
        timestamp: new Date(),
        orderid:
          callData.data.order && callData.data.order.number
            ? callData.data.order.number
            : null,
        managerId:
          callData.data.order && callData.data.order.managerId
            ? callData.data.order.managerId
            : null,
        statusLabel:
          callData.data.order && callData.data.order.statusName
            ? callData.data.order.statusName
            : (callData.data.order && callData.data.order.status
              ? callData.data.order.status
              : null),
        missed: false,
      };

      this.applyManagerLabelToCall(
        incomingCall,
        callData.data.order && callData.data.order.managerId
      );

      // Сохраняем связь phone -> trunk в Vuex
      if (callData.data.phone && callData.data.trunk) {
        this.addPhoneTrunk({ phone: callData.data.phone, trunk: callData.data.trunk });
      }

      this.showCallNotificationControl(incomingCall, "Входящий звонок (Контроль)");
    }
    else if (callData.type === 'bridge') {
    console.log("=== BRIDGE SOBYTIE NA4ALOS ===");
    console.log("Soyedinenie zvonka", callData);
    console.log("UniqueId iz bridge:", callData.data.UniqueId);

    // Получаем все номера из данных события
    const allNumbers = [
        callData.data.ConnectedLineNum,
        callData.data.CallerIDNum,
        callData.data.CallerIDName,
        callData.data.Exten
    ].filter(phone => phone); // Убираем пустые значения

    this.lastBridgeUniqueId = callData.data.UniqueId;
    this.lastBridgeToken = callData.data.Token || null;
    console.log("USTANOVLEN lastBridgeUniqueId:", this.lastBridgeUniqueId);
    console.log("USTANOVLEN lastBridgeToken:", this.lastBridgeToken);

    console.log('Все номера из события:', allNumbers);

    // Определяем внешний номер: начинающийся с `+375` или `375`
    const externalPhone = allNumbers.find(phone => phone.startsWith('+375') || phone.startsWith('375'));

    // Определяем внутренний номер: это 3-значный номер
    const internalPhone = allNumbers.find(phone => /^\d{3}$/.test(phone));

    console.log(`Обнаружен внешний номер: ${externalPhone}`);
    console.log(`Обнаружен внутренний номер: ${internalPhone}`);

    // Если внешний номер не найден, пропускаем обработку
    if (!externalPhone) {
        console.warn("Внешний номер не найден, обработка пропущена.");
        return;
    }
    
    console.log(`=== OBRABOTKA BRIDGE DLYA NOMERA ${externalPhone} ===`);

    // Находим уведомление для удаления
    const notificationEntry = Array.from(this.activeNotifications.entries()).find(
        ([phone]) => phone === externalPhone
    );

    if (notificationEntry) {
        const [originalPhone, toastId] = notificationEntry;
        this.$toast.dismiss(toastId);
        this.activeNotifications.delete(originalPhone);
        // Удаляем из очереди порядка
        const index = this.callNotificationsOrder.indexOf(originalPhone);
        if (index > -1) {
          this.callNotificationsOrder.splice(index, 1);
        }
        console.log(`Уведомление для номера ${originalPhone} удалено`);
    } else {
        console.warn(`Уведомление для номера ${externalPhone} не найдено.`);
    }

    // Удаляем звонок из списка пропущенных
    this.calls = this.calls.filter(call => call.phone !== externalPhone);
    this.saveMissedCallsToStorage();

    const isOutgoingBridge = Number(callData.data.CallType) === 1;
    if (isOutgoingBridge) {
      console.log('Исходящий bridge (CallType=1) — заказ не создаём', externalPhone);
      return;
    }

    // Проверяем внутренний номер и сохраняем данные формы
    console.log(`=== PROVERKA USLOVIY DLYA OBRABOTKI ===`);
    console.log(`internalPhone: ${internalPhone}`);
    const userPhoneExtension = this.$store.state.user && this.$store.state.user.phone_extension;
    console.log(`user.phone_extension: ${userPhoneExtension}`);
    console.log(`Условие совпадения: ${internalPhone == userPhoneExtension}`);
    
    if (
      this.$store.state.user &&
      this.$store.state.user.phone_extension &&
      internalPhone == this.$store.state.user.phone_extension
    ) {
      console.log(
        `Phone extension ${this.$store.state.user.phone_extension} matches internalPhone. Checking for duplicate forms.`
      );

      

      // Поиск trunk по номеру телефона
      console.log("Ищем trunk для телефона:", externalPhone);
      const trunk = this.getTrunkByPhone(externalPhone);
      console.log(`Найден trunk: ${trunk}`)
      
      console.log(trunk);

      if (!trunk) {
        console.warn(`Trunk для номера ${externalPhone} не найден.`);
        return;
      }

      // Определяем источник
      const source = this.getSourceById(trunk);
      console.log(`Источник: ${source.label} (${source.value})`);

      if (this.processingPhones.has(externalPhone)) {
        console.log(`Обработка номера ${externalPhone} уже выполняется, пропускаем.`);
        return;
      }

      // Добавляем номер в "обрабатываемые" (дольше 2с: ждём серверный заказ)
      this.processingPhones.add(externalPhone);

      setTimeout(() => {
        this.processingPhones.delete(externalPhone);
      }, 15000);

     
      // Форма с тем же телефоном И тем же сайтом звонка (orderMethod / callSite)
        const callSiteValue = source && source.value ? source.value : null;
        const existingForm = this.savedForms.find((form) => {
            if (!form.data || form.data.phone !== externalPhone) return false;
            if (!callSiteValue || callSiteValue === 'unknown') return true;
            const formMethod = form.data.orderMethod;
            const formSite = (formMethod && typeof formMethod === 'object')
              ? (formMethod.value || null)
              : (formMethod || form.data.callSite || null);
            // Старые формы без сайта — считаем совпадением, чтобы не плодить дубли
            if (!formSite) return true;
            return formSite === callSiteValue;
        });

        // Если пользователь находится в OrderEdit с этим же номером телефона - не делаем ничего
        if (existingForm && this.$route.name === 'OrderEdit') {
            console.log(`Пользователь уже находится в заказе с номером ${externalPhone}, пропускаем обработку звонка.`);
            return;
        }

        if (existingForm) {
                console.log(`Форма с номером телефона ${externalPhone} уже существует, сохранение отменено.`);
            } else {




            const continueAfterExit = async () => {
              // cancel-group: «Отмена дубль» / «Отмена» тоже считаем существующим (не плодим пустые)
              const defaultStatusGroups = ['new-group', 'delivery-group', 'approval-group', 'assembling-group', 'cancel-group'];
              // Заказ создаёт webhook_server на /bridge. Клиент только ждёт и открывает —
              // иначе гонка с saveCallOrder даёт дубли в Retail.
              const result = await this.waitForAnsweredCallOrder(externalPhone, defaultStatusGroups, {
                attempts: 12,
                delayMs: 700,
                callSite: source && source.value ? source.value : null,
              });

              const {
                number,
                numberOrder,
                managerId = '',
                orderMethod,
                orderType,
                site,
                contragentType,
                createdAt,
                customFieldsManager = null,
              } = result.success ? result : {};

              console.log("=== PROVERKA MANAGERA ===");
              console.log("managerId:", managerId);
              console.log("externalPhone:", externalPhone);
              console.log("number:", number);
              console.log("numberOrder:", numberOrder);
              console.log("result.success:", result.success);

              const normalizedCustomFieldsManager = customFieldsManager ? String(customFieldsManager).trim() : null;
              const normalizedUserSymbolicCode = this.user.symbolicCode ? String(this.user.symbolicCode).trim() : null;
              const orderFound = !!number;
              const managerMatches = normalizedCustomFieldsManager && normalizedUserSymbolicCode &&
                                    normalizedCustomFieldsManager === normalizedUserSymbolicCode;

              console.log("=== PROVERKA SOVPADENIYA MENEDZHERA ===");
              console.log("orderFound:", orderFound);
              console.log("managerMatches:", managerMatches);

              if (orderFound && !normalizedCustomFieldsManager) {
                console.warn("⚠️ ВНИМАНИЕ: Заказ найден, но customFields.manager не заполнен! Это может быть старый заказ.");
              }

              if (orderFound) {
                console.log(managerMatches
                  ? "=== ZAKAZ NAJDEN I MENEDZHER SOVPADAET - OTKRYVAEM SU6ESTVUYu6IY ==="
                  : "=== ZAKAZ NAJDEN, NO MENEDZHER NE SOVPADAET - OTKRYVAEM SU6ESTVUYu6IY ===");
                this.pendingOrderId = number;
                this.saveBridgeCallAsFormOrder(
                  externalPhone,
                  number,
                  numberOrder,
                  managerId,
                  orderMethod,
                  orderType,
                  site,
                  contragentType,
                  createdAt,
                  source
                );
              } else {
                // Не создаём заказ с клиента — только сервер. Иначе снова будут дубли.
                console.warn("=== ZAKAZ NE NAJDEN POSLE OZHIDANIYA SERVERA — NE SOZDAEM S KLIENTA ===");
                console.warn("externalPhone:", externalPhone, "lastBridgeUniqueId:", this.lastBridgeUniqueId);
                this.$toast && this.$toast("Заказ по звонку ещё не появился. Обновите список заказов через несколько секунд.", {
                  timeout: 6000,
                  position: "top-right",
                  type: "warning"
                });
              }
            };

            // Дополнительная проверка связывания через 3 секунды
            setTimeout(() => {
              console.log("=== DOPOLNITELNAYA PROVERKA SVYAZYVANIYA ===");
              console.log("lastBridgeUniqueId:", this.lastBridgeUniqueId);
              if (this.lastBridgeUniqueId) {
                // Проверяем, есть ли order_id у этого звонка
                axios.get(`https://manager.1akb.by/get-call-by-id/${this.lastBridgeUniqueId}`)
                  .then(response => {
                    console.log("=== PROVERKA ZVONKA ===");
                    console.log("Call data:", response.data);
                    if (response.data && response.data.order_id) {
                      console.log("✅ ZVONOK UZHE SVYAZAN S ZAKAZOM:", response.data.order_id);
                    } else {
                      console.warn("⚠️ ZVONOK NE SVYAZAN S ZAKAZOM!");
                    }
                  })
                  .catch(err => {
                    console.error("OSHIBKA PROVERKI ZVONKA:", err);
                  });
              }
            }, 3000);

            // Теперь обрабатываем условие:
            if (this.$route.name === 'OrderEdit' && managerId !== '') {
              console.log('На странице редактирования заказа, ждём сохранение и выход');

              this.requestSaveAndExitOrder().then(() => {
                console.log('Сохранение завершено, продолжаем');
                continueAfterExit();
              });
            } else {
              // Если мы НЕ на странице редактирования — сразу продолжаем
              continueAfterExit();
            }

          }
      
    }

    // Показываем уведомление о соединении
    //this.showCallNotificationExt(callData.data, "Соединение звонка");
}else if (callData.type === 'hangup') {
    console.log("=== HANGUP SOBYTIE NA4ALOS ===");
    console.log("Звонок завершен", callData);

    // Извлекаем данные из события
    const eventData = callData.data;

    // Получаем номер телефона из события
    const allNumbers = [
        eventData.Phone,           // Основной номер
        ...(eventData.Extensions || []) // Дополнительные номера
    ].filter(phone => phone); // Убираем пустые значения

    console.log('Все номера из события hangup:', allNumbers);
    console.log('UniqueId из hangup:', eventData.UniqueId);
    console.log('CallStatus:', eventData.CallStatus);
    console.log('Token:', eventData.Token);

    // Проверяем уведомления для всех номеров
    let notificationRemoved = false;

    allNumbers.forEach(phone => {
        const normalizedPhone = this.normalizePhoneNumber(phone);

        const notificationEntry = Array.from(this.activeNotifications.entries()).find(
            ([savedPhone]) => this.normalizePhoneNumber(savedPhone) === normalizedPhone
        );

        if (notificationEntry) {
            const [originalPhone, toastId] = notificationEntry;
            this.$toast.dismiss(toastId); // Удаляем уведомление
            this.activeNotifications.delete(originalPhone); // Удаляем из activeNotifications
            // Удаляем из очереди порядка
            const index = this.callNotificationsOrder.indexOf(originalPhone);
            if (index > -1) {
              this.callNotificationsOrder.splice(index, 1);
            }
            notificationRemoved = true;
            console.log(`Уведомление для номера ${originalPhone} удалено`);
        }
    });

    if (!notificationRemoved) {
        console.warn('Уведомление не найдено для номера из события hangup.');
    }

    // Привязка order_id при завершении звонка (только для отвеченных звонков)
    // CallStatus == 2 означает, что звонок был отвечен
    if (eventData.CallType == 0 && eventData.CallStatus == 2 && eventData.UniqueId && this.pendingOrderId) {
        console.log('=== PRIVYAZKA ORDER_ID PRI HANGUP ===');
        console.log('UniqueId из hangup:', eventData.UniqueId);
        console.log('pendingOrderId:', this.pendingOrderId);
        
        // В hangup UniqueId совпадает с UniqueId из start
        const uniqueId = eventData.UniqueId;
        const orderId = this.pendingOrderId;
        
        // Обновляем запись в callss
        axios.post('https://manager.1akb.by/set-order-id-calls', {
            callId: uniqueId,
            orderId: orderId
        }).then(response => {
            if (response.data.success) {
                console.log(`✅✅✅ order_id ${orderId} успешно привязан к звонку ${uniqueId}`);
            } else {
                console.warn('⚠️ Не удалось привязать order_id:', response.data);
            }
        }).catch(error => {
            console.error('❌ Ошибка при привязке order_id:', error);
        });
        
        // Очищаем переменную
        this.pendingOrderId = null;
        console.log('pendingOrderId очищен');
    } else if (eventData.CallType == 0 && eventData.CallStatus == 2 && !this.pendingOrderId) {
        console.log('⚠️ pendingOrderId не установлен, привязка не выполнена');
    }
}


},
    handleMatchingCall(callData) {
      console.log(`Входящий звонок для пользователя с phone_extension ${callData.ConnectedLineNum}`);
    },
   showCallNotification(callData, messageType) {
    const disallowedPages = ['CalendarComponent', 'TaskSto'];

    // Если текущий маршрут входит в список исключений, выходим из функции
    if (disallowedPages.includes(this.$route.name)) {
        return;
    }
    if (callData.managerLabel) {
        // Отображаем HTML-уведомление с компонентом CallNotification, если есть managerLabel
        const toastId = this.$toast({
            component: CallNotification,
            props: {
                phone: callData.phone,
                orderid: callData.orderid,
                managerLabel: callData.managerLabel
            }
        }, {
            timeout: 500000,
            position: "bottom-right",
            transition: "Vue-Toastification__fade",
            closeOnClick: true,
            style: {
                background: "linear-gradient(180deg, #0068ff, #005bd5)",
                color: "white",
                width: "240px",
                padding: "8px",
                fontSize: "16px",
                maxHeight: "92px",
                minHeight: "50px",
                minWidth: "240px",
                borderRadius: "2px"
            },
            icon: false
        });

        // Сохраняем уведомление в activeNotifications
        this.activeNotifications.set(callData.phone, toastId);
        // Добавляем в очередь для отслеживания порядка
        if (!this.callNotificationsOrder.includes(callData.phone)) {
          this.callNotificationsOrder.push(callData.phone);
        }
        // Ограничиваем количество уведомлений
        this.limitCallNotifications();
    } else {
        // Отображаем обычное текстовое уведомление
        const message = `${messageType} от ${callData.phone || callData.Exten}`;
        const toastId = this.$toast(message, {
            timeout: 500000,
            position: "bottom-right",
            transition: "Vue-Toastification__fade",
            closeOnClick: true,
            style: {
                background: "linear-gradient(180deg, #0068ff, #005bd5)",
                color: "white",
                width: "240px",
                padding: "8px",
                fontSize: "16px",
                maxHeight: "92px",
                minHeight: "50px",
                minWidth: "240px",
                borderRadius: "2px"
            },
            icon: false
        });

        // Сохраняем уведомление в activeNotifications
        this.activeNotifications.set(callData.phone, toastId);
        // Добавляем в очередь для отслеживания порядка
        if (!this.callNotificationsOrder.includes(callData.phone)) {
          this.callNotificationsOrder.push(callData.phone);
        }
        // Ограничиваем количество уведомлений
        this.limitCallNotifications();
    }
},


showCallNotificationSTO(callData, messageType) {
  // Проверяем, на нужном ли маршруте мы сейчас
    const allowedPages = ['CalendarComponent', 'TaskSto'];
    if (!allowedPages.includes(this.$route.name)) {
        return; // Если текущий маршрут не входит в список, не показываем уведомление
    }

    if (callData.managerLabel) {
        // Отображаем HTML-уведомление с компонентом CallNotification, если есть managerLabel
        const toastId = this.$toast({
            component: CallNotification,
            props: {
                phone: callData.phone,
                orderid: callData.orderid,
                managerLabel: callData.managerLabel
            }
        }, {
            timeout: 500000,
            position: "bottom-right",
            transition: "Vue-Toastification__fade",
            closeOnClick: true,
            style: {
                background: "linear-gradient(90deg, rgba(255,210,103,1) 0%, rgba(255,138,11,1) 65%)",
                color: "white",
                width: "240px",
                padding: "8px",
                fontSize: "16px",
                maxHeight: "92px",
                minHeight: "50px",
                minWidth: "240px",
                borderRadius: "2px"
            },
            icon: false
        });

        // Сохраняем уведомление в activeNotifications
        this.activeNotifications.set(callData.phone, toastId);
        // Добавляем в очередь для отслеживания порядка
        if (!this.callNotificationsOrder.includes(callData.phone)) {
          this.callNotificationsOrder.push(callData.phone);
        }
        // Ограничиваем количество уведомлений
        this.limitCallNotifications();
    } else {
        // Отображаем обычное текстовое уведомление
        const message = `${messageType} от ${callData.phone || callData.Exten}`;
        const toastId = this.$toast(message, {
            timeout: 500000,
            position: "bottom-right",
            transition: "Vue-Toastification__fade",
            closeOnClick: true,
            style: {
                background: "linear-gradient(90deg, rgba(255,210,103,1) 0%, rgba(255,138,11,1) 65%)",
                color: "white",
                width: "240px",
                padding: "8px",
                fontSize: "16px",
                maxHeight: "92px",
                minHeight: "50px",
                minWidth: "240px",
                borderRadius: "2px"
            },
            icon: false
        });

        // Сохраняем уведомление в activeNotifications
        this.activeNotifications.set(callData.phone, toastId);
        // Добавляем в очередь для отслеживания порядка
        if (!this.callNotificationsOrder.includes(callData.phone)) {
          this.callNotificationsOrder.push(callData.phone);
        }
        // Ограничиваем количество уведомлений
        this.limitCallNotifications();
    }
},

showCallNotificationControl(callData, messageType) {
    // Для отдела контроля показываем уведомления на всех страницах

    // Кастомная кнопка специально под Vue 2
const CustomCloseButton = {
    props: ['closeToast'],
    render(h) {
        return h('div', { 
            style: { display: 'flex', gap: '8px', alignItems: 'center', paddingLeft: '10px' } 
        }, [
            // Кнопка копирования с SVG
            h('button', {
                on: { 
                    click: (e) => { 
                        e.stopPropagation(); 
                        // Предполагается, что callData доступен в замыкании
                        const textToCopy = callData.phone || callData.Exten;
                        navigator.clipboard.writeText(textToCopy); 
                    } 
                },
                style: { 
                    background: 'rgba(255, 255, 255, 0.2)', 
                    border: 'none', 
                    color: 'white', 
                    borderRadius: '4px', 
                    padding: '6px', // Немного увеличил паддинг для иконки
                    cursor: 'pointer', 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }
            }, [
                // Отрисовка SVG
                h('svg', {
                    attrs: {
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '20', // Установленный размер
                        height: '20',
                        viewBox: '0 0 2048 2048',
                        fill: 'currentColor' // Чтобы иконка наследовала цвет текста (белый)
                    }
                }, [
                    h('path', {
                        attrs: {
                            d: 'M416 0h979v1l31 4 22 6 21 9 16 9 16 12 10 9 13 13 12 16 11 19 9 21 5 18 3 17 1 12v133h129l22 2 15 3 17 5 18 8 18 10 17 13 13 12 10 11 10 14 9 15 7 15 6 17 5 22 2 21v1406l-2 19-4 20-6 18-7 16-13 21-13 16-16 16-19 14-20 11-20 8-15 4-17 3-12 1H711l-21-2-20-5-19-7-16-8-16-10-13-11-11-10-7-8-9-11-12-19-9-19-6-18-4-20-2-20v-129H420l-23-2-20-4-20-7-19-9-11-7-16-12-15-14-7-8-10-13-9-15-8-16-6-16-5-21-2-15-1-26V177l1-18 3-19 6-21 6-15 10-19 12-17 11-12 14-14 15-11 15-9 14-7 24-8 15-3 22-3zm10 94-16 1-13 3-16 8-9 6-8 7-10 13-7 14-4 13-1 6-1 1399 1 16 4 16 8 16 8 11 8 8 13 9 10 5 14 4 8 1 117 1h717l151-1 11-2 12-4 15-8 11-9 8-9 8-13 5-13 2-9 1-10V169l-3-16-5-13-7-12-11-12-8-7-14-8-15-5-5-1-21-1zm1139 298-1 1187-2 19-5 21-7 19-11 21-8 12-11 13-7 8-11 10-17 12-14 8-15 7-18 6-18 4-15 2-44 1H640l-1 1v132l2 11 4 12 7 13 7 9 10 10 12 8 11 5 17 4 13 1h936l42-1 16-4 16-8 10-7 11-11 7-11 6-13 3-11 1-7V465l-3-16-7-16-7-11-13-13-11-7-10-5-13-4-6-1'
                        }
                    })
                ])
            ]),
            
            // Кнопка закрытия (крестик)
            h('button', {
                on: { 
                    click: (e) => { 
                        e.stopPropagation(); 
                        if (typeof this.closeToast === 'function') {
                            this.closeToast(); // Вызываем как функцию
                        }
                    } 
                },
                style: { background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' }
            }, '✕')
        ]);
    }
};

    if (callData.orderid) {
        // Отображаем HTML-уведомление с компонентом CallNotification, если есть номер заказа
        const toastId = this.$toast({
            component: CallNotification,
            props: {
                phone: callData.phone,
                orderid: callData.orderid,
                managerLabel: callData.managerLabel || null,
                statusLabel: callData.statusLabel || null
            }
        }, {
            timeout: 500000,
            position: "bottom-right",
            transition: "Vue-Toastification__fade",
            closeOnClick: true,
            closeButton: CustomCloseButton, // <-- Вставили кнопки сюда
            style: {
                background: "linear-gradient(180deg, #6f42c1, #5a32a3)",
                color: "white",
                width: "260px",
                padding: "8px",
                fontSize: "16px",
                maxHeight: "130px",
                minHeight: "50px",
                minWidth: "260px",
                borderRadius: "2px"
            },
            icon: false
        });

        // Сохраняем уведомление в activeNotifications
        this.activeNotifications.set(callData.phone, toastId);
        // Добавляем в очередь для отслеживания порядка
        if (!this.callNotificationsOrder.includes(callData.phone)) {
          this.callNotificationsOrder.push(callData.phone);
        }
        // Ограничиваем количество уведомлений
        this.limitCallNotifications();
    } else {
        // Отображаем обычное текстовое уведомление без номера заказа
        const message = `${messageType} от ${callData.phone || callData.Exten}`;
        const toastId = this.$toast(message, {
            timeout: 500000,
            position: "bottom-right",
            transition: "Vue-Toastification__fade",
            closeOnClick: true,
            closeButton: CustomCloseButton, // <-- И сюда
            style: {
                background: "linear-gradient(180deg, #6f42c1, #5a32a3)",
                color: "white",
                width: "260px",
                padding: "8px",
                fontSize: "16px",
                maxHeight: "92px",
                minHeight: "50px",
                minWidth: "260px",
                borderRadius: "2px"
            },
            icon: false
        });

        // Сохраняем уведомление в activeNotifications
        this.activeNotifications.set(callData.phone, toastId);
        // Добавляем в очередь для отслеживания порядка
        if (!this.callNotificationsOrder.includes(callData.phone)) {
          this.callNotificationsOrder.push(callData.phone);
        }
        // Ограничиваем количество уведомлений
        this.limitCallNotifications();
    }
},

showCallNotificationTasks(callData, messageType) {
  // Старый toast-путь оставлен для совместимости; основной UI — TaskReminderPanel
  this.enqueueTaskReminder({
    id: callData.id,
    taskText: callData.taskText || 'Задача',
    orderIdLink: callData.orderIdLink || callData.orderId,
    orderId: callData.orderId,
    dueDate: callData.dueDate || '',
    managerLabel: callData.managerLabel || 'Не указан',
  });
},

enqueueTaskReminder(task) {
  const disallowedPages = ['CalendarComponent', 'TaskSto'];
  if (disallowedPages.includes(this.$route.name)) {
    return;
  }
  if (!task || !task.id) return;
  const exists = this.taskReminders.some((t) => String(t.id) === String(task.id));
  if (exists) return;
  this.taskReminders = [...this.taskReminders, {
    id: task.id,
    taskText: task.taskText || 'Задача',
    orderId: task.orderId || '',
    orderIdLink: task.orderIdLink || task.orderId || '',
    dueDate: task.dueDate || '',
    managerLabel: task.managerLabel || '',
  }];
},

removeTaskReminder(taskId) {
  this.taskReminders = this.taskReminders.filter((t) => String(t.id) !== String(taskId));
  this.activeNotifications.delete(taskId);
},

formatTaskDueDate(date) {
  const d = date instanceof Date ? date : new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
},

openTaskReminderOrder(task) {
  const orderId = task && (task.orderIdLink || task.orderId);
  if (!orderId) return;
  this.$store.dispatch('savedFormsModule/clearSavedForms');
  this.$store.commit('clearProducts');
  this.$router.push({
    name: 'OrderEdit',
    params: { orderId },
  }).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
},

async completeTaskReminder(task) {
  if (!task || !task.id) return;
  try {
    await this.markTaskAsViewed(task.id);
    this.removeTaskReminder(task.id);
  } catch (e) {
    console.error('Ошибка при завершении задачи:', e);
  }
},

async snoozeTaskReminder(task) {
  if (!task || !task.id) return;
  const dueDate = this.formatTaskDueDate(new Date(Date.now() + 5 * 60 * 1000));
  try {
    const response = await fetch('https://manager.1akb.by/updateTaskFields', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: task.id,
        dueDate,
        viewed: 'false',
        activity: 'active',
      }),
    });
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    this.removeTaskReminder(task.id);
    if (this.$toast) {
      this.$toast.info(`Задача отложена до ${dueDate}`, {
        timeout: 2500,
        position: 'bottom-right',
        style: { padding: '10px', minHeight: '40px', display: 'flex', alignItems: 'center' },
      });
    }
  } catch (error) {
    console.error('Ошибка при откладывании задачи:', error);
    if (this.$toast) {
      this.$toast.error('Не удалось отложить задачу', { timeout: 2500, position: 'bottom-right' });
    }
  }
},

openOrder(){
  console.log('открываю таск');
},

async requestSaveAndExitOrder() {
  return new Promise((resolve) => {
    this.$root.$emit('save-and-exit-order', resolve); // передаём resolve внутрь
  });
},

async markTaskAsViewed(taskId) {
        try {
            const response = await fetch('https://manager.1akb.by/updateTaskFields', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: taskId, viewed: '1' }) // Обновляем поле viewed
            });

            if (!response.ok) {
                throw new Error(`Ошибка: ${response.statusText}`);
            }

            console.log(`Задача ${taskId} отмечена как просмотренная`);
            this.activeNotifications.delete(taskId); // Удаляем из активных
            this.removeTaskReminder(taskId);
        } catch (error) {
            console.error("Ошибка при обновлении viewed:", error);
            throw error;
        }
    },


    showCallNotificationExt(callData, messageType) {
      console.log(`Отображение уведомления: ${messageType} от ${callData.phone || callData.Exten}`);
      
      this.$toast(`${messageType} от ${callData.phone || callData.Exten}`, {
        timeout: 500000,
        position: "bottom-right",
        transition: "Vue-Toastification__fade",
        closeOnClick: true,
         style: {
          background: "linear-gradient(180deg, #22c993, #20a77f)",
            color: "white",
            width: "240px",
            padding: "8px",
            fontSize: "16px",
            maxHeight: "50px",
            minHeight: "50px",
            minWidth: "240px",
            borderRadius: "2px"
        },
        icon: false
        
      });
    },
    setupWebSocket(reconnectAttempt = 0) {
      const socket = new WebSocket('wss://manager.1akb.by/ws');
      console.log("🔌 Подключение к WebSocket...");

      socket.onopen = () => {
        console.log("✅ WebSocket соединение установлено");

        // Сбрасываем счётчик переподключений
        reconnectAttempt = 0;

        const sendUserOnline = () => {
          const user = this.$store.state.user;
          if (!user || !socket || socket.readyState !== WebSocket.OPEN) return;
          if (!user.retailCrmId && !user.id) return;
          try {
            socket.send(JSON.stringify({
              type: 'userOnline',
              user: {
                id: user.id,
                label: user.label,
                retailCrmId: user.retailCrmId != null ? user.retailCrmId : user.id,
                symbolicCode: user.symbolicCode,
                role: user.role
              }
            }));
          } catch (err) {
            console.error('Ошибка отправки userOnline:', err);
          }
        };
        // Сначала подтянуть статус с сервера (чтобы после F5/reconnect не затереть «Отошел» дефолтным online),
        // затем userOnline, затем явно подтвердить статус. Повторный userOnline через 1с раньше сбрасывал away.
        const restorePresence = async () => {
          try {
            await this.fetchCurrentManagerStatus();
          } catch (e) {}
          sendUserOnline();
          this.sendWsManagerStatus(this.currentManagerStatus);
        };
        restorePresence();
        setTimeout(() => {
          sendUserOnline();
          this.sendWsManagerStatus(this.currentManagerStatus);
        }, 1000);

        // Пинг для удержания соединения
        this.pingInterval = setInterval(() => {
          if (socket.readyState === WebSocket.OPEN) {
            try {
              socket.send(JSON.stringify({ type: 'ping' }));
            } catch (err) {
              console.error('❗ Ошибка при отправке ping:', err);
            }
          }
        }, 30000); // каждые 30 секунд
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.handleIncomingCall(data);
      };

      socket.onerror = (error) => {
        console.error('❌ WebSocket error:', error);
      };

      socket.onclose = (event) => {
        console.warn('🔌 WebSocket закрыт:', {
          code: event.code,
          reason: event.reason,
          wasClean: event.wasClean
        });

        clearInterval(this.pingInterval);

        // Переподключение с задержкой (увеличиваем при ошибках)
        const reconnectDelay = Math.min(5000 * (reconnectAttempt + 1), 30000); // max 30 сек
        console.log(`🔄 Попытка переподключения через ${reconnectDelay / 1000} секунд...`);

        setTimeout(() => {
          this.setupWebSocket(reconnectAttempt + 1);
        }, reconnectDelay);
      };

      // Привязка
      this.ws = socket;
      Vue.prototype.$ws = socket;
    },
    
  },
  beforeDestroy() {
    if (this.loggedInTodayInterval) clearInterval(this.loggedInTodayInterval);
    clearTimeout(this.logoutTimer);
    clearTimeout(this.inactivityTimer);
    document.removeEventListener('mousemove', this.resetInactivityTimer);
    document.removeEventListener('keydown', this.resetInactivityTimer);
    document.removeEventListener('click', this.resetInactivityTimer);
    document.removeEventListener('scroll', this.resetInactivityTimer);
  },
};
</script>






<style>

    

body {
  color: #1e2248;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
  font-size: 14px;
  line-height: 1.5;
  background: #f4f6f8;
}

:root {
  --consultantMainColor: #005eeb;
  --consultantMainColorDark: #0054d1;
  --consultantMainColorDarkest: #0049b8;
  --consultantMainColorAlpha: rgba(0,94,235,.12);
  --consultantMainTextColor: #fff;
  --consultantMainIconColor: #fff;
  --consultantStatusTextColor: hsla(0,0%,95%,.8);
  --consultantMainGrayColor: #636f7f;
  --consultantOffsetBottom: 20px;
  --consultantBgColor: #fff;
  --consultantBorderColor: #dee2e6;
  --consultantFooterBgColor: #f4f6f8;
  --consultantAreaBgColor: #fff;
  --consultantAreaTextColor: #000;
  --consultantAreaIconColor: #afb9c3;
  --consultantAreaBorderColor: #dee2e6;
  --consultantAreaHoverBorderColor: #dee2e6;
  --consultantMsgBgColor: #f4f6f8;
  --consultantMsgTextColor: #1e2248;
  --consultantMsgDateColor: #8a96a6;
  --consultantCornersRadius: 8px;
  --outlinedButtonColor: var(--consultantMainColorDarkest);
  --outlinedButtonHoverColor: #fff;
}
:root {
  --landing-primary-color: #4191ff;
  --landing-secondary-color: #005eeb;
  --landing-tag-background: rgba(0,94,235,.12);
  --landing-badge-color: #0052cc;
  --landing-badge-background: #b8dbff;
}
:root {
  --player-background: #21254f;
  --player-buttons-fill: #fff;
  --player-text-color: #fff;
  --player-progress-background: #e9ecee;
  --player-speed-background: #f4f6f8;
}
:root {
  --red-100: #ffeded;
  --red-200: #ffb1a6;
  --red-300: #ff8e87;
  --red-400: #ff6a68;
  --red-500: #ff5353;
  --red-600: #dd4040;
  --red-700: #b73232;
  --red-800: #932121;
  --red-900: #932121;
  --red-transparent: rgba(255,83,83,.1);
  --blue-100: #edf4ff;
  --blue-200: #b8dbff;
  --blue-300: #6cadff;
  --blue-400: #4191ff;
  --blue-500: #005eeb;
  --blue-600: #0052cc;
  --blue-700: #0044b7;
  --blue-800: #0033a2;
  --blue-900: #00228c;
  --blue-transparent: rgba(0,94,235,.12);
  --yellow-100: #fff9f0;
  --yellow-200: #ffe1ba;
  --yellow-300: #ffd298;
  --yellow-400: #fec375;
  --yellow-500: #fea530;
  --yellow-600: #ef8e06;
  --yellow-700: #e18001;
  --yellow-800: #bc6b01;
  --yellow-900: #965601;
  --yellow-transparent: rgba(254,165,48,.12);
  --green-100: #d8f8ee;
  --green-200: #b7ebd8;
  --green-300: #6ce0b9;
  --green-400: #4cd6a8;
  --green-500: #22c993;
  --green-600: #20a77f;
  --green-700: #19976e;
  --green-800: #168561;
  --green-900: #106349;
  --green-transparent: rgba(34,201,147,.16);
  --purple-100: #e5dbf8;
  --purple-200: #c1a9ef;
  --purple-300: #a37ee7;
  --purple-400: #8453df;
  --purple-500: #6528d7;
  --purple-600: #4a2aa5;
  --purple-700: #402590;
  --purple-800: #371f7c;
  --purple-900: #2d1a68;
  --purple-transparent: rgba(101,40,215,.12);
  --black-100: #323976;
  --black-200: #2d336c;
  --black-300: #262b5a;
  --black-400: #21254f;
  --black-500: #1e2248;
  --black-600: #1a1d3e;
  --black-700: #151833;
  --black-800: #111329;
  --black-900: #0d0f1f;
  --grey-100: #f9fafb;
  --grey-200: #f4f6f8;
  --grey-300: #eef1f3;
  --grey-400: #e9ecee;
  --grey-500: #dee2e6;
  --grey-600: #c7cdd4;
  --grey-700: #afb9c3;
  --grey-800: #8a96a6;
  --grey-900: #636f7f;
}
:root {
  --input-color: #1e2248;
  --input-border-color: #dee2e6;
  --input-padding: 1px 10px;
  --input-font-size: 13px;
  --input-line-height: 26px;
  --input-height: 35px;
  --input-border-radius: 6px;
  --input-box-shadow: none;
  --input-placeholder-color: #afb9c3;
  --input-arrow-color: #1e2248;
  --input-focus-box-shadow: 0 0 0 4px rgba(0,94,235,.12);
  --input-focus-border-color: #005eeb;
  --input-hover-border-color: #afb9c3;
  --input-disabled-border-color: #c7cdd4;
  --input-disabled-background: #eef1f3;
  --input-disabled-color: #8a96a6;
  --input-transition: 0.2s ease;
  --dropdown-border-radius: 8px;
  --dropdown-box-shadow: 0px 8px 16px rgba(30,34,72,.16);
  --dropdown-list-padding: 2px 4px;
  --dropdown-list-max-height: 240px;
  --dropdown-list-min-height: 31px;
  --dropdown-item-color: #1e2248;
  --dropdown-item-border-radius: 4px;
  --dropdown-item-hover-background: rgba(0,94,235,.12);
  --dropdown-item-padding: 5px 10px 6px;
  --choice-item-color: #1e2248;
  --choice-item-background: #eef1f3;
  --choice-item-border: 1px solid #eef1f3;
  --choice-item-border-radius: 3px;
  --choice-item-line-height: 13px;
  --choice-item-margin: 3px 3px 0 0;
  --choice-item-padding: 4px 18px 3px 5px;
  --choice-item-close-color: #afb9c3;
  --choice-item-close-hover-color: #636f7f;
}

#app { max-width: 98%;
margin: 0 auto;
}

.content-container {
  width: 100%;
}

.bk {
   
display: flex;
flex-wrap: wrap;
padding-bottom: 20px;
}

.sticky-saved-orders{
  transition: 0.3s;
}
.sticky-saved-orders.minimized {
  min-width: 30px;
}

.arrowCont {
  width: 100%;
  display: flex;
  justify-content: start;
}
.arrowCont .arrowHide {
  width: 30px;
    height: 30px;
    background: #21b486;
    text-align: center;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
    border: 0px solid #ccc;
    color: #fff;

}

.arrowCont .arrowHide:hover {
  cursor: pointer;
  background: #3d3d3d;
}
 .hidElem {
  margin-top: 38px;
  min-width: 170px;
  max-width: 170px;
}
.arrowCont .arrowHide:hover svg {
  fill: #fff;
}


.arrowCont .arrowHide svg path{
  fill: #fff;
}

.collapse-section {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    margin-top: 24px;
}

.collapse-section__head {
    align-items: center;
    border-bottom: 0px solid #dee2e6;
    display: flex;
    height: 10px;
    justify-content: space-between;
    padding: 20px 0 20px 20px;
    position: relative;
    transition: border-color .2s linear;
    font-weight: 800;
}

.collapse-section__title {
    align-items: center;
    color: #111;
    display: flex;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
}

.collapse-section__head-col {
  align-items: center;
  display: flex;
}

.collapse-section__btn {
  align-items: center;
  border-top-right-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 63px;
  justify-content: center;
  margin: -20px 0 -20px 8px;
  transition: background .2s linear,margin .2s linear,height .2s linear;
  width: 63px;
}

.collapse-section__btn svg {
  fill: #afb9c3;
  height: 24px;
  transition: transform .2s linear,fill .2s linear;
  width: 24px;
}


.section-error {
  align-items: center;
  color: #ff5353;
  display: flex;
}

.collapse-section:not(.collapse-section_collapse) .section-error, .collapse-section:not(.collapse-section_error) .section-error {
  display: none;
}

.section-error__icon {
  height: 20px;
  margin-right: 4px;
  width: 20px;
}

.section-error__text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
}


.section-error__text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
}

.section-error__text_require {
  display: none;
}

.field-for-group {
     padding: 8px 0 40px;
    display: flex;
    flex-wrap: wrap;
}


.input-group {
  float: left;
padding: 20px 20px 0;
position: relative;
width: 45%;
display: flex;
align-items: center;
flex-wrap:nowrap;
}

.main-form .input-group {
  min-height: 50px;
}


.cleared::after {
  clear: both;
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
}

.main-form_break-labels label {
  word-break: break-word;
}


label {
 margin-bottom: 4px;
display: block;
font-size: 12px;
  font-style: normal;
  line-height: 1.2;
  padding: 6px 10px 0 0;
color: #636f7f;
min-width: 90px;
max-width: 90px;
margin-right: 5px;
}

.label-common {
  color: #636f7f;
  display: block;
  float: left;
  font-size: 13px;
  font-style: normal;
  line-height: 1.2;
  padding: 6px 10px 0 0;
    padding-right: 10px;
  width: 120px;
}

.main-form_break-labels .label-common {
  word-break: break-word;
}

/*.input-group label.required {
  padding-right: 12px;
}*/



label.required::after {
  color: #ff5353;
  content: "*";
  font-size: 17px;
  font-weight: 700;
  line-height: 17px;
  padding-left: 3px;
  padding-top: 0;
  position: absolute;
  vertical-align: middle;
}

#order-customer input {
    padding: 0px 16px;
}


.input-group label.required::after {
  position: absolute;
}


select {
  background-color: #fff;
}


.input-field {
  float: left;
}

.input-group .checkbox-list, .input-group .chosen-container, .input-group .input-field, .input-group.courier-group, .input-group .v-select {
  max-width: 463px;
width: 100%;
height: 32px;
border: solid 0px #7b7b7b42;
border-radius: 4px;
}


.vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: flex;
  padding: 0 0 4px;
  background: none;
  border: 0px solid rgba(60,60,60,.26);
  border-radius: 4px;
  white-space: normal;
}

* {
  margin: 0;
  padding: 0;
}
*, ::after, ::before {
  box-sizing: inherit;
}

.vs__search, .vs__search:focus {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: 24px!important;
  font-size: 12px!important;
  border: 1px solid transparent;
    border-left-color: transparent;
    border-left-style: solid;
    border-left-width: 1px;
  border-left-color: transparent;
  border-left-style: solid;
  border-left-width: 1px;
  border-left: none;
  outline: none;
  margin: 2px 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  z-index: 1;
}

.vs__selected {
  display: flex;
  align-items: center;
  background-color: #f0f0f0;
  border: 1px solid rgba(60,60,60,.26);
    border-top-color: rgba(60, 60, 60, 0.26);
    border-right-color: rgba(60, 60, 60, 0.26);
    border-bottom-color: rgba(60, 60, 60, 0.26);
    border-left-color: rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  color: #333;
  line-height: 1.4;
  margin: 1px 2px 0;
  padding: 0 .25em;
  z-index: 0;
  font-size: 12px;
}

.m-box .bk {
  border-top: 1px solid #dee2e6;
}

.bk-control {
  padding: 0 0 0 30px;
  width: 100%;
  display: block;
}

.ml0 {
  margin-left: 0 !important;
}

.fs10 {
  font-size: 10px !important;
}
.red-tl {
  background: #005eeb;
  color: #fff !important;
  display: inline-block;
  letter-spacing: .1em;
  margin-right: 40px;
  padding: 1px 12px 3px;
  position: relative;
  text-transform: uppercase;
}
.bk-control > div {
  color: #3483b2;
  float: left;
  font-size: 10px;
}

.red-tl::after, .red-tl::before {
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  display: block;
  height: 19px;
  position: absolute;
  top: 0;
  width: 12px;
}

.red-tl::before {
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 19%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23005EEB%27 d=%27M12 19c-3.3 0-6-2.7-6-6V6c0-3.3-2.7-6-6-6h12v19z%27/%3E%3C/svg%3E");
  right: 100%;
}

.red-tl::after {
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 19%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23005EEB%27 d=%27M0 0h12C8.7 0 6 2.7 6 6v7c0 3.3-2.7 6-6 6V0z%27/%3E%3C/svg%3E");
  left: 100%;
}


.vs--open .vs__open-indicator {
    transform: rotate(180deg) scale(0.5)!important;
}

.vs__open-indicator {
  fill: rgba(60,60,60,.5);
  transform: scale(0.5)!important;
  transition: transform .15s cubic-bezier(1,-.115,.975,.855);
    transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1,-.115,.975,.855);
}

.input-group .input-field[type="checkbox"] {
  width: auto;
}

#legal-details-form textarea.input-field {
  height: 76px;
}

textarea.input-field {
  display: block;
  font-family: inherit;
  height: 140px;
  line-height: 18px;
  padding-top: 5px;
  resize: none;
}


.btn.white {
  background-color: #fff;
  background-image: linear-gradient(180deg,#fff,#e9ecee);
  border: 1px solid #dee2e6;
  text-shadow: none;
}
.bk-btn .btn, .btn-wrapper .btn {
  margin-bottom: 0;
  margin-right: 0;
}

.btn {
  background: none;
    background-color: rgba(0, 0, 0, 0);
    background-image: none;
  background-color: #005eeb;
  background-image: linear-gradient(180deg,#0068ff,#005bd5);
  border: none;
  border-radius: 6px;
color: #000;
cursor: pointer;
display: inline-block;
font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
font-size: 14px;
font-weight: 400;
font-weight: 500;
height: 21px;
line-height: 20px;
padding: 8px 20px;
  padding-top: 8px;
  padding-bottom: 8px;
padding-top: 8px;
padding-bottom: 8px;
text-decoration: none;
user-select: none;
vertical-align: middle;
}

.icon-new {
  display: inline-block;
  height: 10px;
  margin-left: 8px;
  position: relative;
  top: 1px;
  width: 10px;
}

.icon-new::before {
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%2322C993%27 d=%27M10 4H6V0H4v4H0v2h4v4h2V6h4z%27/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}


.modern-table.order-products {
  border-collapse: collapse;
width: 100%;
}


table {
  border-collapse: separate;
  border-spacing: 0;
}

.order-products__counter-cell {
  color: #636f7f !important;
  padding-right: 0 !important;
  text-align: left !important;
}

.order-products__counter-cell_th {
  padding-left: 16px !important;
}

.modern-table tr th {
  background: #f9fafb;
    background-color: rgb(249, 250, 251);
  border-bottom: 1px solid #dee2e6;
  border-left: none;
  color: #636f7f;
  font-size: 11px;
  font-weight: 400;
  padding: 14px 5px;
    padding-right: 5px;
    padding-left: 5px;
  text-align: right;
}

.modern-table.order-products tr th {
  line-height: 10px;
}

.modern-table.order-products tr th.title {
  width: 90px;
}


.modern-table.order-products tr .heading-th {
  width: 180px;
}

.modern-table.order-products tr td.bord, .modern-table.order-products tr th.bord {
  border-right: 1px solid #dee2e6;
}


.order-row {
  background-color: #f9fafb;
  border-bottom: 1px solid #dee2e6;
  padding: 16px 24px;
}

.order-row__top {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.order-row__title {
  align-items: center;
  color: #636f7f;
  display: inline-flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.42857143;
}

.order-discount, .order-discount__input-wrap {
  display: flex;
  position: relative;
}

.order-table-footer {
  display: flex;
  padding: 0 24px;
}



.order-table-footer__left, .order-table-footer__right {
  padding: 24px 0;
    padding-right: 0px;
}

.order-table-footer__left {
  display: flex;
  flex-grow: 1;
  padding-right: 24px;
}

.m-box.order-products-table-box .patch-target {
  transition: .3s;
}


table td {
  empty-cells: show;
}

.order-products__counter-cell {
  color: #636f7f !important;
  text-align: left !important;
}


.modern-table tr td {
  color: #1e2248;
  font-size: 12px;
  text-align: right;
}

.order-table-footer__list {
  list-style: none;
}

.order-table-footer__list-item {
  align-items: center;
  display: flex;
}

.order-table-footer__list-item:not(:last-child) {
  margin-bottom: 8px;
}

.m-box__left-side {
  width: 63%;
}
.ft-lt {
  float: left;
}

.order-compos {
  margin-bottom: 30px;
}
.m-box__right-side {
  width: 34%;
}
.ft-rt {
  float: right;
}




.min-input, input[type="email"].input-field, input[type="number"].input-field, input[type="password"].input-field, input[type="text"].input-field, select, textarea {
  border: 1px solid var(--input-border-color)!important;
  border-radius: var(--input-border-radius)!important;
  box-shadow: var(--input-box-shadow)!important;
  color: var(--input-color)!important;
  font-size: var(--input-font-size)!important;
  height: var(--input-height)!important;
  line-height: var(--input-line-height)!important;
  padding: var(--input-padding)!important;
  transition: var(--input-transition)!important;
}

textarea.input-field {
  display: block;
  font-family: inherit;
  height: 140px;
  line-height: 18px;
  padding-top: 5px;
  resize: none;
}

.m-box-content {
    width: 100%;
padding: 20px
}

.input-field.wide {
  width: 94%;
}




.batch-box, .save-box {
  bottom: 0;
  left: 0px;
  margin: 0 auto;
  padding-left: 40px;
  padding-right: 40px;
  position: fixed;
  right: 0;
  text-align: center;
  transition: left .25s linear !important;
  width: 100%;
  z-index: 200;
}

.batch-box, .save-box {
  padding-left: 0;
  padding-right: 0;
  transition: .25s linear .1s;
  width: auto;
}

.open-menu .batch-box, .open-menu .save-box {
  left: 320px;
}



.batch-box .wrapper, .save-box .wrapper {
  background-color: #fff;
  border-top: 0px solid #dee2e6;
  transition: background-color .4s ease-out;
}

.save-box .wrapper {
  padding-left: 60px;
  padding-right: 60px;
}

.save-box .wrapper {
  min-height: 56px;
  padding-bottom: 9px;
  padding-top: 10px;
  position: relative;
}

.batch-box .wrapper::after, .batch-box .wrapper::before, .save-box .wrapper::after, .save-box .wrapper::before {
  content: " ";
  display: table;
}

.save-box .btn__block {
  float: left;
  margin-left: 0;
}

.inline-tooltip-wrap {
  position: relative;
}

.del-btn, .delete-button {
  background: none;
    background-color: rgba(0, 0, 0, 0);
    background-image: none;
  background-color: transparent;
  background-image: linear-gradient(180deg,#fff,#e9ecee);
  border: 1px solid #dee2e6;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 36px;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-decoration: none;
  text-indent: 1000em;
  text-shadow: none;
  user-select: none;
  white-space: nowrap;
  width: 36px;
}

.del-btn, .del-btn:focus, .delete-button, .delete-button:focus {
  outline: none;
}

.del-btn, .del-btn.active, .del-btn:active, .del-btn:hover, .delete-button, .delete-button.active, .delete-button:active, .delete-button:hover {
  color: #1e2248;
  text-decoration: none;
}

.save-box .del-btn {
  background-color: transparent;
  background-image: none;
  border: none;
  float: right;
  transition: .2s;
}

.del-btn::before, .delete-button::before {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 0;
  content: "";
  display: block;
  height: 24px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
}


.save-box .del-btn::before {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23AFB9C3' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  height: 24px;
  transition: .2s;
  width: 24px;
}

.btn_success {
  background-image: linear-gradient(180deg,#22c993,#20a77f);
  color: #fff;
}


.mx-icon-calendar, .mx-icon-clear {
    position: absolute;
    top: 16px!important;
    right: -10px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-42%);
    font-size: 16px;
    line-height: 1;
    color: rgba(0, 0, 0, .5);
    vertical-align: middle;
}

.mx-input-wrapper {
    position: initial;
}

.mx-datepicker {
    position: relative;
    display: inline-block;
    width: 212px;
}

.mx-table-date .today {
    color: #ffffff !important;
    background: #2a90e9 !important;
}

.vs__clear svg {
 transform: scale(0.6);
}



    .modal-content {
       background: white;
        padding: 20px;
        max-width: 80%;
        max-height: 80%;
        overflow-y: auto;
        position: relative;
        right: 0;
        left: 0;
        z-index: 1040;
        --default-padding: 56px 296px;
        max-width: 1192px;
        width: 100%;
        height: 100%;
        margin: 40px auto;
        border-radius: 0px;
        background: #fafafa;
        max-height: calc(100vh - 80px);
        overflow: hidden;
        margin: 60px auto 40px auto;
        overflow-y: auto;
        position: relative;

    }

    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
  
    .loader-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    .spinner {
        border: 6px solid #f3f3f3; /* Light grey */
        border-top: 6px solid #bdbdbd; /* Blue */
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 1s linear infinite;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    .close-btn {
        margin-top: 20px;
        background-color: #f44336;
        color: white;
        border: none;
        padding: 10px 20px;
        cursor: pointer;
        position: absolute;
        bottom: 20px;
        right: 20px;
    }

    .btn:hover {
        opacity: .5;
    }

    .content-container {
  display: flex;
  align-items: flex-start; /* Начало по вертикали */
  gap: 10px; /* Расстояние между колонками */
}

/* Левая колонка (router-view) */
router-view {
  flex: 1; /* Занимает оставшееся пространство */
}

/* Правая колонка с липким компонентом */
.sticky-saved-orders {
  position: sticky;
  top: 36px; /* Регулируйте отступ сверху по своему усмотрению */
  
  z-index: 10; /* Слой выше других элементов при необходимости */
 
}

.vs__dropdown-toggle {
    border: 1px solid rgba(60, 60, 60, .26);
}


.phone_icon {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' style='shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd'%3e%3cpath fill='%23fefffe' d='M277.5-.5h12c104.845 23.53 175.679 85.864 212.5 187a503.138 503.138 0 0 1 9.5 37v9c-5.458 10.198-13.458 12.698-24 7.5l-3.5-3.5C469.001 156.906 426.834 96.74 357.5 56c-26.136-14.045-53.802-23.712-83-29-9.874-10.441-8.874-19.608 3-27.5Z' style='opacity:.958'/%3e%3cpath fill='%23fefffe' d='M381.5 511.5h-28c-28.815-4.324-56.481-12.824-83-25.5C163.94 433.773 83.44 354.94 29 249.5c-14.802-29.566-24.635-60.566-29.5-93v-26c1.952-13.678 6.785-26.345 14.5-38A545.237 545.237 0 0 1 69.5 37c21.868-12.567 42.534-10.9 62 5a1855.233 1855.233 0 0 1 71.5 73.5c12.766 23.757 9.766 45.423-9 65L160.5 214c12.934 25.7 29.434 48.867 49.5 69.5 24.901 27.093 53.567 49.093 86 66a965.629 965.629 0 0 0 37.5-36.5c23.285-18.265 46.285-17.931 69 1l61.5 61.5c19.631 21.462 21.631 44.462 6 69a1765.816 1765.816 0 0 1-49.5 50.5c-11.803 8.539-24.803 14.039-39 16.5Zm-285-453c4.683.439 9.016 1.939 13 4.5l66.5 66.5c7.154 10.304 6.154 19.971-3 29a1101.106 1101.106 0 0 1-40 39c-4.129 5.699-5.462 12.032-4 19a226.895 226.895 0 0 0 25 47c28.999 39.668 63.833 73.168 104.5 100.5l30 16c9.672 3.236 18.338 1.57 26-5l41-41c8.557-6.189 16.89-5.855 25 1a3173.43 3173.43 0 0 1 66.5 67.5c4.667 7.333 4.667 14.667 0 22a1564.09 1564.09 0 0 1-46.5 47.5c-13.749 8.883-28.749 11.883-45 9a214.824 214.824 0 0 1-55-15C185.258 414.758 101.091 331.925 48 217.5c-10.483-23.434-16.65-47.934-18.5-73.5-.395-13.058 3.105-24.891 10.5-35.5L85.5 63c3.553-2.12 7.22-3.62 11-4.5Z' style='opacity:.959'/%3e%3cpath fill='%23fefffe' d='M277.5 91.5c66.203 12.096 111.203 49.596 135 112.5 4.165 10.819 5.998 21.985 5.5 33.5-4.462 8.479-11.296 11.313-20.5 8.5a25.55 25.55 0 0 1-6.5-5.5c-9.644-50.491-37.478-86.991-83.5-109.5a195.367 195.367 0 0 0-35-10c-11.123-8.204-11.79-17.204-2-27 2.427-.902 4.76-1.736 7-2.5Z' style='opacity:.955'/%3e%3c/svg%3e");
  background-size: contain;
    width: 20px;
    height: 20px;
    background-position: center;
    background-repeat: no-repeat;
}

.Vue-Toastification__toast-body {
    flex: 1;
    line-height: 24px;
    font-size: 12px;
    word-break: break-word;
    white-space: pre-wrap;
    line-height: 16px;
}

.Vue-Toastification__progress-bar {
  height:2px;
}

#app {margin-bottom: 300px;}


.calls-display-settings select:hover {
  border-color: #adb5bd;
}

.calls-display-settings select:focus {
  outline: none;
  border-color: #0068ff;
  box-shadow: 0 0 0 2px rgba(0, 104, 255, 0.1);
}

.logout-container {
      text-align: right;
    margin: 0px;
    margin-top: 50px;
    width: 100%;
}

.logout-button {
  padding: 8px 16px;
  background-color: #f44336;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.logout-button:hover {
  background-color: #d32f2f;
}

.logged-in-today {
  margin-top: 8px;
  font-size: 12px;
  color: #555;
  line-height: 1.4;
}

.modalChats {
  position: absolute;
    width: 400px;
    height: 400px;
    z-index: 9999;
    top: 108px;
    display: none;
}


</style>
